<!-- Modal (WhatsApp Oficial) -->

<ng-template #whatsappOficialAtendimento let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title"><b>WhatsApp Oficial</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body modal-whatsapp-oficial-body">
    @if (whatsappOficialUrl != null) {
      <iframe class="whatsapp-oficial-frame" [src]="whatsappOficialUrl"></iframe>
    }
  </div>
</ng-template>

<!-- Modal (Alterar Agendamento) -->

<ng-template #alterarAgendamento let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-alterar-agendamento"><b>Alterar (Agendamento)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="height: 360px;">
    <div class="form-row">
      <div class="form-group offset-4 col-sm-2">
        <label><b>Data:</b></label>

        <input class="form-control form-control-sm" type="text" name="alterar_ligacao_data" [ngClass]="{ 'is-invalid': alterarLigacaoDataInvalida }" ngbDatepicker #alterar_ligacao_data="ngbDatepicker" (click)="alterar_ligacao_data.toggle()" [(ngModel)]="alterarLigacaoData" />

        @if (alterarLigacaoDataInvalida) {
          <div class="erro pt-1">Data inválida!</div>
        }
      </div>

      <div class="form-group col-sm-2">
        <label><b>Hora:</b></label>

        <ngb-timepicker name="alterar_ligacao_hora" [spinners]="false" [(ngModel)]="alterarLigacaoHora"></ngb-timepicker>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Salvar')">Salvar</button>
  </div>
</ng-template>

<!-- Modal (Alterar Visita) -->

<ng-template #alterarVisita let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-alterar-visita"><b>Alterar (Visita)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <div class="form-group col-sm-9">
        <label><b>Vendedor(a):</b></label>

        <input class="form-control form-control-sm" type="text" name="alterar_visita_vendedor" [value]="visitaSelecionada == null ? '' : visitaSelecionada.fullname" disabled />
      </div>

      <div class="form-group col-sm-3">
        <label><b>Check-in:</b></label>

        <input class="form-control form-control-sm" type="text" name="alterar_visita_check_in" [value]="visitaSelecionada == null ? '' : visitaSelecionada.check_in | date: 'dd/MM/yyyy HH:mm:ss'" disabled />
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Resultado:</b></label>

        <input class="form-control form-control-sm" type="text" name="alterar_visita_resultado" [value]="visitaSelecionada == null ? '' : visitaSelecionada.name" disabled />
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Observação:</b></label>

        <textarea class="form-control form-control-sm" rows="5" name="alterar_visita_observacao" [(ngModel)]="observacaoVisita"></textarea>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Salvar')">Salvar</button>
  </div>
</ng-template>

<!-- Modal (Notas Fiscais (Sintéticas)) -->

<ng-template #notasFiscaisSinteticas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-notas-fiscais-sinteticas"><b>Notas fiscais e duplicatas</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <app-pedido-modal-notas-fiscais [notasFiscais]="notasFiscais"></app-pedido-modal-notas-fiscais>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Locais de Entrega) -->

<ng-template #equipeComercialCliente>
  @if (cliente != null) {
    <div class="cliente_equipe" aria-label="Equipe comercial do cliente">
      <div class="cliente_equipe_item">
        <i class="fa fa-user cliente_equipe_icone" aria-hidden="true"></i>
        <div>
          <div class="cliente_grid_label">Vendedor</div>
          <div class="cliente_grid_valor">{{ cliente.fullname || 'Não vinculado' }}</div>
        </div>
      </div>
      <div class="cliente_equipe_item">
        <i class="fa fa-users cliente_equipe_icone" aria-hidden="true"></i>
        <div>
          <div class="cliente_grid_label">Coordenador</div>
          <div class="cliente_grid_valor">{{ cliente.nome_gerente || 'Não vinculado' }}</div>
        </div>
      </div>
      <div class="cliente_equipe_item">
        <i class="fa fa-users cliente_equipe_icone" aria-hidden="true"></i>
        <div>
          <div class="cliente_grid_label">Venda Interna</div>
          <div class="cliente_grid_valor">{{ cliente.nome_venda_interna || 'Não vinculado' }}</div>
        </div>
      </div>
    </div>
  }
</ng-template>

<ng-template #locaisEntregaModal let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-locais-entrega"><b>Locais de Entrega do Cliente</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    @if (loadingLocalEntrega) {
      <div class="text-center p-3">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Carregando...</span>
        </div>
        <p class="mt-2 text-secondary">Carregando locais de entrega...</p>
      </div>
    }

    @if (erroLocalEntrega) {
      <div class="text-center p-3 text-danger">
        {{ erroLocalEntrega }}
      </div>
    }

    @if (!loadingLocalEntrega && !erroLocalEntrega && locaisEntrega.length == 0) {
      <div class="text-center p-3 text-secondary">
        Nenhum local de entrega cadastrado.
      </div>
    }

    @if (!loadingLocalEntrega && !erroLocalEntrega && locaisEntrega.length > 0) {
      <div class="table-responsive">
        <table class="table table-sm">
          <thead>
            <tr>
              <th class="text-left">Local de Entrega</th>
              <th class="text-center tabela_borda">Cidade/UF</th>
              <th class="text-center tabela_borda">CEP</th>
              <th class="text-left tabela_borda">Endereço</th>
              <th class="text-center tabela_borda">Nº</th>
              <th class="text-left tabela_borda">Bairro</th>
              <th class="text-center tabela_borda">Ativo</th>
            </tr>
          </thead>
          <tbody>
            @for (local of locaisEntrega; track local) {
              <tr>
                <td class="text-left">{{ local.localentrega }}</td>
                <td class="text-center tabela_borda">{{ local.cidadeentrega }}/{{ local.ufentrega }}</td>
                <td class="text-center tabela_borda">{{ local.cepentrega }}</td>
                <td class="text-left tabela_borda">{{ local.enderecoentrega }}</td>
                <td class="text-center tabela_borda">{{ local.nrentrega }}</td>
                <td class="text-left tabela_borda">{{ local.bairroentrega }}</td>
                <td class="text-center tabela_borda">{{ local.ativo ? 'Sim' : 'Não' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Negócios Kanban) -->

<ng-template #kanbanNegociosModal let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title"><b>Negócios do cliente</b></h3>
    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    @if (kanbanNegociosCarregando) {
      <div class="text-center p-3">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Carregando...</span>
        </div>
        <p class="mt-2 text-secondary">Carregando negócios...</p>
      </div>
    }
    @if (!kanbanNegociosCarregando && kanbanNegociosCliente.length == 0) {
      <div class="text-center p-3 text-secondary">
        Nenhum negócio aberto para este cliente.
      </div>
    }
    @if (!kanbanNegociosCarregando && kanbanNegociosCliente.length > 0) {
      <div class="kanban-negocios-lista">
        @for (negocio of kanbanNegociosCliente; track negocio) {
          <div class="kanban-negocio-item">
            <div>
              <strong>{{ negocio.nome_negocio }}</strong>
              <span>{{ negocio.departamento_nome }} / {{ negocio.etapa_nome }}</span>
              <small>
                Responsável: {{ negocio.seller_responsavel_nome }}
                @if (negocio.valor_negociacao) {
                  | {{ negocio.valor_negociacao | currency:'BRL':'symbol':'1.2-2':'pt' }}
                }
              </small>
            </div>
          </div>
        }
      </div>
    }
  </div>
  <div class="modal-footer flex-wrap">
    <button class="btn btn-outline-primary btn_formulario" type="button" (click)="abrirKanbanFiltradoCliente(modal)">Abrir Kanban</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

@if (!carregando && ligacao != null) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4 d-flex justify-content-between align-items-center">
      <div>
        @if (clienteConsultaSelecionadoExterno == 0) {
          <div class="titulo_texto">Call Center - Ligação</div>
        }
        @if (clienteConsultaSelecionadoExterno != 0) {
          <div class="titulo_texto">Consultar - Cliente</div>
        }
      </div>
      <div class="ia-atalhos" *ngIf="cliente != null">
        <button type="button" class="btn ia-atalho" (click)="alternarPainelIa()" ngbTooltip="IA NAPIS" placement="bottom" aria-label="IA NAPIS">
          <i class="fa fa-magic"></i>
          <span>NEW</span>
        </button>
        <button type="button" class="btn ia-atalho ia-atalho-produtos" (click)="sugerirProdutosIa()" [disabled]="iaCarregando" ngbTooltip="Sugerir Produtos" placement="bottom" aria-label="Sugerir Produtos">
          <i class="fa fa-lightbulb-o"></i>
        </button>
      </div>
    </div>
    <!-- Itens (Menu) -->
    <div class="pt-3 pr-4 pb-0 pl-4">
      <div class="d-flex flex-wrap justify-content-center itens_menu">
        <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="itemSelecionado == 0 ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(0)">
          1. Dados do Cliente
        </div>
        @if (callCenterConfiguracao.usa_tela_qualificacao) {
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="itemSelecionado == 1 ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(1)">
            2. Qualificação do Cliente
          </div>
        }
        @if (callCenterConfiguracao.usa_tela_cesta) {
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="itemSelecionado == 2 ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(2)">
            {{ callCenterConfiguracao.usa_tela_qualificacao ? '3' : '2' }}. Cesta
          </div>
        }
        <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="itemSelecionado == 3 ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(3)">
          {{ callCenterConfiguracao.usa_tela_qualificacao && callCenterConfiguracao.usa_tela_cesta ? '4' : callCenterConfiguracao.usa_tela_qualificacao || callCenterConfiguracao.usa_tela_cesta ? '3' : '2' }}. Análise de Vendas
        </div>
        <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="itemSelecionado == 4 ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(4)">
          {{ callCenterConfiguracao.usa_tela_qualificacao && callCenterConfiguracao.usa_tela_cesta ? '5' : callCenterConfiguracao.usa_tela_qualificacao || callCenterConfiguracao.usa_tela_cesta ? '4' : '3' }}. Histórico de Pedidos
        </div>
        <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="itemSelecionado == 5 ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(5)">
          {{ callCenterConfiguracao.usa_tela_qualificacao && callCenterConfiguracao.usa_tela_cesta ? '6' : callCenterConfiguracao.usa_tela_qualificacao || callCenterConfiguracao.usa_tela_cesta ? '5' : '4' }}. Histórico de Ligações
        </div>
        @if (clienteConsultaSelecionadoExterno == 0) {
          <div class="item_menu pt-2 pb-2 pl-3 mr-0" [ngClass]="itemSelecionado == 6 ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(6)">
            {{ callCenterConfiguracao.usa_tela_qualificacao && callCenterConfiguracao.usa_tela_cesta ? '7' : callCenterConfiguracao.usa_tela_qualificacao || callCenterConfiguracao.usa_tela_cesta ? '6' : '5' }}. Concluir Ligação
          </div>
        }
      </div>
      <hr class="mt-2 mb-2" />
    </div>
    <!-- Cliente -->
    @if (cliente != null) {
      <div class="pr-4 pl-4">
        @if (cliente.bloqueado === 1) {
          <div class="alert alert-danger mb-2">
            <strong>CLIENTE BLOQUEADO</strong>
            @if (cliente.status_bloqueado) {
              <span> — {{ cliente.status_bloqueado }}</span>
            }
          </div>
        }
        @if (modelo_tela_ligacoes == 0) {
          <!-- Modelo 1 -->
          <div class="cliente_header" [class.cliente_header_alerta]="cliente.status_financeiro != null">
            <div class="cliente_header_top">
              <!-- Identidade -->
              <div class="cliente_identidade">
                <div class="cliente_nome">
                  <span class="cliente_codigo">{{ cliente.codigo_no_erp_do_cliente }}</span> &middot; {{ cliente.name }}
                </div>
                <div class="cliente_meta_chips">
                  @if (cliente.client_document != null && cliente.client_document != '') {
                    <span class="cliente_chip cliente_chip_doc">{{ cliente.client_document }}</span>
                  }
                  @if (cliente.responsible_name != null && cliente.responsible_name != '') {
                    <span class="cliente_chip"><i class="fa fa-user"></i> {{ cliente.responsible_name }}</span>
                  }
                  <span class="cliente_chip">
                    Notas fiscais: {{ cliente.status_financeiro != null ? 'INADIMPLENTE' : '-' }}
                    @if (cliente.client_document != null && cliente.client_document != '') {
                      <i class="fa fa-info-circle cliente_chip_acao" placement="top" ngbTooltip="Notas Fiscais" (click)="modalNotasFiscaisSinteticas(notasFiscaisSinteticas, cliente.client_document)"></i>
                    }
                  </span>
                  <span class="cliente_chip" [ngClass]="cliente.status_financeiro != null ? 'cliente_chip_alerta' : 'cliente_chip_ok'">
                    <i class="fa" [ngClass]="cliente.status_financeiro != null ? 'fa-exclamation-circle' : 'fa-check-circle'"></i>
                    {{ cliente.status_financeiro != null ? 'Inadimplente' : 'Adimplente' }}
                  </span>
                </div>
              </div>

              <!-- Ações -->
              <div class="cliente_acoes">
                <button class="cliente_acao_btn" type="button" (click)="modalLocaisEntrega(locaisEntregaModal)" [disabled]="cliente.client_id_app == null">
                  <i class="fa fa-truck"></i> Locais de Entrega
                </button>
                @if (kanbanNegociosCliente.length > 0) {
                  <button class="cliente_acao_btn" type="button" (click)="abrirKanbanNegocios(kanbanNegociosModal)">
                    <i class="fa fa-briefcase"></i> Negócios
                  </button>
                }
                @if ((is_master || is_diretor) && cliente.codigo_no_erp_do_cliente) {
                  <button class="cliente_acao_btn" type="button" (click)="abrirAnaliseFinanceiraCliente(resumoFinanceiroModalCC)">
                    <i class="fa fa-bar-chart"></i> Análise Financeira
                  </button>
                }
                @if (exibirAtualizarClienteTr()) {
                  <button class="cliente_acao_btn cliente_acao_btn_tr" type="button" (click)="atualizarClienteTr()" [disabled]="atualizandoClienteTr">
                    <i class="fa fa-refresh"></i> {{ atualizandoClienteTr ? 'Atualizando...' : 'Atualizar Cliente TR' }}
                  </button>
                }
              </div>

              <!-- Limite -->
              @if (cliente.limite_credito_disponivel != null) {
                <div class="cliente_limite">
                  <div class="cliente_limite_label">Limite disponivel</div>
                  <div class="cliente_limite_valor" [class.cliente_limite_valor_zero]="cliente.limite_credito_disponivel == 0">{{ cliente.limite_credito_disponivel | currency: 'BRL' }}</div>
                </div>
              }
              @if (cliente.credito_financeiro != null) {
                <div class="cliente_limite">
                  <div class="cliente_limite_label">Credito disponivel</div>
                  <div class="cliente_limite_valor" [class.cliente_limite_valor_zero]="cliente.credito_financeiro == 0">{{ cliente.credito_financeiro | currency: 'BRL' }}</div>
                </div>
              }
            </div>

            <ng-container *ngTemplateOutlet="equipeComercialCliente"></ng-container>

            <!-- Segmentação -->
            <div class="cliente_grid">
              @if (cliente.segment) {
                <div class="cliente_grid_item">
                  <div class="cliente_grid_label">Segmento</div>
                  <div class="cliente_grid_valor">{{ cliente.segment }}</div>
                </div>
              }
              @if (cliente.ramo_atividade) {
                <div class="cliente_grid_item">
                  <div class="cliente_grid_label">Ramo Atividade</div>
                  <div class="cliente_grid_valor">{{ cliente.ramo_atividade }}</div>
                </div>
              }
              @if (cliente.subsegmento) {
                <div class="cliente_grid_item">
                  <div class="cliente_grid_label">Subsegmento</div>
                  <div class="cliente_grid_valor">{{ cliente.subsegmento }}</div>
                </div>
              }
              @if (cliente.subsegmento2) {
                <div class="cliente_grid_item">
                  <div class="cliente_grid_label">Subsegmento2</div>
                  <div class="cliente_grid_valor">{{ cliente.subsegmento2 }}</div>
                </div>
              }
              @if (cliente.rede_postos) {
                <div class="cliente_grid_item">
                  <div class="cliente_grid_label">Rede Postos</div>
                  <div class="cliente_grid_valor">{{ cliente.rede_postos }}</div>
                </div>
              }
              @if (cliente.grupo_regiao) {
                <div class="cliente_grid_item">
                  <div class="cliente_grid_label">Grupo Região</div>
                  <div class="cliente_grid_valor">{{ cliente.grupo_regiao }}</div>
                </div>
              }
            </div>
          </div>
        }
        @if (modelo_tela_ligacoes == 1) {
          <!-- Modelo 2 -->
          <div class="quadro_cliente p-2">
            <ng-container *ngTemplateOutlet="equipeComercialCliente"></ng-container>
            <div class="d-flex flex-wrap justify-content-between">
              <div class="d-flex flex-column">
                <!-- Cliente -->
                <div class="quadro_cliente_item">
                  <h6 class="text-secondary"><b>Cliente:</b></h6>
                  <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>({{ cliente.codigo_no_erp_do_cliente }}) - {{ cliente.name }}</b></h6>
                </div>
                <!-- Cidade -->
                <div class="quadro_cliente_item">
                  <h6 class="text-secondary"><b>Cidade:</b></h6>
                  <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>{{ cliente.cidade }}</b></h6>
                </div>
              </div>
              <div class="d-flex flex-column">
                <!-- CNPJ/CPF -->
                <div class="quadro_cliente_item">
                  <h6 class="text-secondary"><b>CNPJ/CPF:</b></h6>
                  <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>{{ cliente.client_document }}</b></h6>
                </div>
                <!-- Estado -->
                <div class="quadro_cliente_item">
                  <h6 class="text-secondary"><b>Estado:</b></h6>
                  <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>{{ cliente.estado }}</b></h6>
                </div>
              </div>
              <div class="d-flex flex-column">
                <!-- PV -->
                <div class="quadro_cliente_item">
                  <h6 class="text-secondary"><b>PV:</b></h6>
                  <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>{{ cliente.pv }}</b></h6>
                </div>
                <!-- Segmento -->
                @if (cliente.segment) {
                  <div class="quadro_cliente_item">
                    <h6 class="text-secondary"><b>Segmento:</b></h6>
                    <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>{{ cliente.segment }}</b></h6>
                  </div>
                }
              </div>
              <div class="d-flex flex-column">
                <!-- Código GE -->
                <div class="quadro_cliente_item">
                  <h6 class="text-secondary"><b>Código GE:</b></h6>
                  <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>{{ cliente.codigo_ge }}</b></h6>
                </div>
                <!-- Zona de Vendas -->
                <div class="quadro_cliente_item">
                  <h6 class="text-secondary"><b>Zona de Vendas:</b></h6>
                  <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>{{ cliente.zona_vendas }}</b></h6>
                </div>
              </div>
              <div class="d-flex flex-column">
                <!-- Nome GE -->
                <div class="quadro_cliente_item">
                  <h6 class="text-secondary"><b>Nome GE:</b></h6>
                  <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>{{ cliente.nome_ge }}</b></h6>
                </div>
                <!-- Locais de Entrega -->
                <div class="quadro_cliente_item d-flex align-items-center">
                <button class="btn btn-sm btn-outline-primary" type="button" (click)="modalLocaisEntrega(locaisEntregaModal)" [disabled]="cliente.client_id_app == null">
                  <i class="fa fa-truck"></i> Locais de Entrega
                </button>
                @if (exibirAtualizarClienteTr()) {
                  <button class="btn btn-sm btn-success cliente_acao_btn_tr_modelo2" type="button" (click)="atualizarClienteTr()" [disabled]="atualizandoClienteTr">
                    <i class="fa fa-refresh"></i> {{ atualizandoClienteTr ? 'Atualizando...' : 'Atualizar Cliente TR' }}
                  </button>
                }
              </div>
            </div>
              @if (cliente.ramo_atividade || cliente.grupo_regiao) {
                <div class="d-flex flex-column">
                  <!-- Ramo Atividade -->
                  @if (cliente.ramo_atividade) {
                    <div class="quadro_cliente_item">
                      <h6 class="text-secondary"><b>Ramo Atividade:</b></h6>
                      <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>{{ cliente.ramo_atividade }}</b></h6>
                    </div>
                  }
                  <!-- Grupo Região -->
                  @if (cliente.grupo_regiao) {
                    <div class="quadro_cliente_item">
                      <h6 class="text-secondary"><b>Grupo Região:</b></h6>
                      <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>{{ cliente.grupo_regiao }}</b></h6>
                    </div>
                  }
                </div>
              }
              @if (cliente.subsegmento || cliente.subsegmento2) {
                <div class="d-flex flex-column">
                  <!-- Subsegmento -->
                  @if (cliente.subsegmento) {
                    <div class="quadro_cliente_item">
                      <h6 class="text-secondary"><b>Subsegmento:</b></h6>
                      <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>{{ cliente.subsegmento }}</b></h6>
                    </div>
                  }
                  <!-- Subsegmento2 -->
                  @if (cliente.subsegmento2) {
                    <div class="quadro_cliente_item">
                      <h6 class="text-secondary"><b>Subsegmento2:</b></h6>
                      <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>{{ cliente.subsegmento2 }}</b></h6>
                    </div>
                  }
                </div>
              }
              @if (cliente.rede_postos) {
                <div class="d-flex flex-column">
                  <!-- Rede Postos -->
                  <div class="quadro_cliente_item">
                    <h6 class="text-secondary"><b>Rede Postos:</b></h6>
                    <h6 [ngClass]="cliente.status_financeiro != null ? 'cliente_inadimplente' : 'cliente_adimplente'"><b>{{ cliente.rede_postos }}</b></h6>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <hr class="mt-2 mb-2" />
      </div>
    }
    <!-- Dados do Cliente -->
    @if (itemSelecionado == 0) {
      <div [@desvanecer]="'in'">
        <div class="pr-4 pb-4 pl-4">
          <!-- Formulário -->
          <div class="cliente_contato">
            <!-- Endereço -->
            <div class="cliente_contato_secao">
              <div class="cliente_contato_secao_head">
                <span class="cliente_contato_titulo">Endereço</span>
                <div class="cliente_inside_sales">
                  <span>Inside Sales</span>
                  <div class="cliente_inside_sales_toggle">
                    <button type="button" [class.on]="!insideSales" (click)="selecionarInsadeSales('0')">Não</button>
                    <button type="button" [class.on]="insideSales" (click)="selecionarInsadeSales('1')">Sim</button>
                  </div>
                </div>
              </div>
              <div class="cliente_contato_grid cols-2">
                <div class="cliente_campo">
                  <label class="cliente_campo_label">Contato</label>
                  <input class="cliente_campo_input" type="text" name="contatoCliente" [(ngModel)]="contatoCliente" />
                </div>
                <div class="cliente_campo">
                  <label class="cliente_campo_label">Endereço completo</label>
                  <div class="cliente_campo_display">{{ cliente.endereco_completo }}</div>
                </div>
              </div>
            </div>

            <!-- Contatos -->
            <div class="cliente_contato_secao">
              <div class="cliente_contato_secao_head">
                <span class="cliente_contato_titulo">Contatos</span>
              </div>
              <div class="cliente_contato_grid">
                <!-- Telefone 1 -->
                <div class="cliente_campo">
                  <label class="cliente_campo_label">Telefone 1</label>
                  <div class="cliente_campo_display">
                    <span>{{ cliente.phone }}</span>
                    @if (callCenterConfiguracao.integrado_pabx && usa_pabx) {
                      <i class="fa fa-phone cliente_icone_acao" placement="top" ngbTooltip="Iniciar Chamada" (click)="iniciarChamada(cliente.phone)"></i>
                    }
                  </div>
                </div>
                <!-- Telefone 2 -->
                <div class="cliente_campo">
                  <label class="cliente_campo_label">Telefone 2</label>
                  <div class="cliente_campo_input_group">
                    <input class="cliente_campo_input" type="number" name="telefone_2" maxlength="20" [(ngModel)]="telefone_2" (keypress)="removerCaracteres($event)" (paste)="removerCaracteresTelefone($event, 2)" />
                    @if (callCenterConfiguracao.integrado_pabx && usa_pabx && telefone_2) {
                      <i class="fa fa-phone cliente_icone_acao" placement="top" ngbTooltip="Iniciar Chamada" (click)="iniciarChamada(telefone_2)"></i>
                    }
                  </div>
                </div>
                <!-- Telefone 3 -->
                <div class="cliente_campo">
                  <label class="cliente_campo_label">Telefone 3</label>
                  <div class="cliente_campo_input_group">
                    <input class="cliente_campo_input" type="number" name="telefone_3" maxlength="20" [(ngModel)]="telefone_3" (keypress)="removerCaracteres($event)" (paste)="removerCaracteresTelefone($event, 3)" />
                    @if (callCenterConfiguracao.integrado_pabx && usa_pabx && telefone_3) {
                      <i class="fa fa-phone cliente_icone_acao" placement="top" ngbTooltip="Iniciar Chamada" (click)="iniciarChamada(telefone_3)"></i>
                    }
                  </div>
                </div>
                <!-- WhatsApp (DDD + Telefone) -->
                <div class="cliente_campo cliente_campo_span2">
                  <label class="cliente_campo_label">WhatsApp</label>
                  <div class="cliente_campo_input_group cliente_whatsapp_row">
                    <input class="cliente_campo_input cliente_whatsapp_ddd" type="text" maxlength="2" name="dddWhatsApp" [(ngModel)]="dddWhatsApp" #ddd_whatsapp (input)="somenteNumeros(ddd_whatsapp)" (focusout)="updateClienteWhatsApp()" (keypress)="removerCaracteres($event)" />
                    <input class="cliente_campo_input" type="text" maxlength="20" name="telefoneWhatsApp" [(ngModel)]="telefoneWhatsApp" #telefone_whatsapp (input)="somenteNumeros(telefone_whatsapp)" (focusout)="updateClienteWhatsApp()" (keypress)="removerCaracteres($event)" />
                    @if (temWhatsAppOficialCliente()) {
                      <button
                        class="cliente_icone_acao_btn"
                        type="button"
                        placement="top"
                        ngbTooltip="Abrir atendimento no WhatsApp"
                        [disabled]="whatsappOficialAbrindo"
                        (click)="abrirWhatsAppOficialAtendimento(whatsappOficialAtendimento)">
                        <i class="fa fa-whatsapp"></i>
                      </button>
                    }
                  </div>
                </div>
              </div>
              <div class="cliente_contato_grid cols-2 mt-2">
                <!-- E-mail 1 -->
                <div class="cliente_campo">
                  <label class="cliente_campo_label">E-mail 1</label>
                  <div class="cliente_campo_display">{{ cliente.email }}</div>
                </div>
                <!-- E-mail 2 -->
                <div class="cliente_campo">
                  <label class="cliente_campo_label">E-mail 2</label>
                  <input class="cliente_campo_input" type="text" name="email_02" [(ngModel)]="email_02" />
                </div>
              </div>
            </div>

            <!-- Time & Observações -->
            <div class="cliente_contato_secao">
              <div class="cliente_contato_secao_head">
                <span class="cliente_contato_titulo">Time &amp; Observações</span>
              </div>
              <div class="cliente_contato_grid cols-2">
                <div class="cliente_campo">
                  <label class="cliente_campo_label">Vendedor(a)</label>
                  <div class="cliente_campo_display">{{ cliente.fullname }}</div>
                </div>
                <div class="cliente_campo">
                  <label class="cliente_campo_label">Observação do cliente</label>
                  <textarea class="cliente_campo_input" rows="1" name="observacaoCliente" [(ngModel)]="observacaoCliente"></textarea>
                </div>
              </div>
            </div>
          </div>
          <!-- Agendamentos -->
          @if (callCenterAgendamentos.length > 0) {
            <hr class="mt-2 mb-2" />
            <div class="d-flex flex-column">
              <div class="quadro_historico p-2">
                <div class="text-center pb-2">
                  <b>Agendamentos</b>
                </div>
                <div class="bg-white">
                  <div class="table-responsive">
                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th></th>
                          <th class="tabela_borda"></th>
                          <th class="tabela_borda">Data/Hora</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (callCenterAgendamento of callCenterAgendamentos; track callCenterAgendamento) {
                          <tr>
                            <td class="text-center tabela_acao">
                              <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="modalAlterarAgendamento(alterarAgendamento, callCenterAgendamento.id)"></i>
                            </td>
                            <td class="text-center tabela_acao tabela_borda">
                              <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Excluir" (click)="deletarAgendamento(callCenterAgendamento.id)"></i>
                            </td>
                            <td class="tabela_borda">{{ callCenterAgendamento.data_ligacao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          }
          <!-- Ações -->
          @if (clienteConsultaSelecionadoExterno == 0) {
            <hr class="mt-2 mb-2" />
            <div class="d-flex flex-wrap justify-content-end">
              @if (pedidoSelecionadoExterno == 0 && statusSelecionado.id_status != 4 && pedidoNaoEnviadoClienteHoje == null) {
                <button class="btn btn-success btn_formulario" type="button" (click)="novoPedidoOrcamento()">Novo Pedido / Orçamento</button>
              }
              @if (pedidoNaoEnviadoClienteHoje != null) {
                <button class="btn btn-success btn_formulario" type="button" (click)="alterarPedidoOrcamento()">Alterar Pedido / Orçamento</button>
              }
              <button class="btn btn-secondary btn_formulario" type="button" (click)="alterarItemSelecionado(6)">Concluir</button>
            </div>
          }
          @if (clienteConsultaSelecionadoExterno != 0) {
            <hr class="mt-2 mb-2" />
            <div class="d-flex flex-wrap justify-content-end">
              <button class="btn btn-secondary btn_formulario" type="button" (click)="retornarDashboardOportunidades()">Retornar</button>
              <button class="btn btn-success btn_formulario" type="button" (click)="updateCliente()">Salvar</button>
            </div>
          }
        </div>
      </div>
    }
    <!-- Qualificação do Cliente -->
    @if (itemSelecionado == 1) {
      <div [@desvanecer]="'in'">
        <div class="pr-4 pb-4 pl-4">
          <div class="d-flex flex-column">
            <form [formGroup]="formQualificacaoQuestoes" (ngSubmit)="addQualificacaoQuestoes()">
              @for (callCenterQualificacaoQuestao of callCenterQualificacaoQuestoes; track callCenterQualificacaoQuestao; let i = $index) {
                <div class="form-row">
                  <div class="form-group col-sm-12">
                    <label><b>{{ callCenterQualificacaoQuestao.descricao }}</b></label>
                    <!-- Escrita -->
                    @if (callCenterQualificacaoQuestao.tipo == 'escrita') {
                      <div>
                        <input class="form-control form-control-sm" type="text" name="qualificacao_questao_{{ i }}" [ngClass]="{ 'is-invalid': qualificacaoQuestoesEnviado && formQualificacaoQuestoes.controls[callCenterQualificacaoQuestao.id].errors?.required }" [formControlName]="callCenterQualificacaoQuestao.id" />
                      </div>
                    }
                    <!-- Múltipla Escolha -->
                    @if (callCenterQualificacaoQuestao.tipo == 'multipla_escolha' && callCenterQualificacaoQuestao.alternativas != null) {
                      <div>
                        <ngx-bootstrap-multiselect [texts]="multiSelectConfiguracoesTextos" [settings]="multiSelectConfiguracoes" [options]="callCenterQualificacaoQuestao.opcoes" [ngClass]="{ 'is-invalid': qualificacaoQuestoesEnviado && formQualificacaoQuestoes.controls[callCenterQualificacaoQuestao.id].errors?.required }" [formControlName]="callCenterQualificacaoQuestao.id"></ngx-bootstrap-multiselect>
                      </div>
                    }
                    <!-- Única Alternativa -->
                    @if (callCenterQualificacaoQuestao.tipo == 'unica_alternativa' && callCenterQualificacaoQuestao.alternativas != null) {
                      <div>
                        <select class="form-control form-control-sm" name="qualificacao_questao_{{ i }}" [ngClass]="{ 'is-invalid': qualificacaoQuestoesEnviado && formQualificacaoQuestoes.controls[callCenterQualificacaoQuestao.id].errors?.required }" [formControlName]="callCenterQualificacaoQuestao.id">
                          <option value=""></option>
                          @for (opcao of callCenterQualificacaoQuestao.alternativas; track opcao) {
                            <option [value]="opcao.id" [selected]="opcao.id == formQualificacaoQuestoes.controls[callCenterQualificacaoQuestao.id].value">{{ opcao.descricao }}</option>
                          }
                        </select>
                      </div>
                    }
                    @if (qualificacaoQuestoesEnviado && formQualificacaoQuestoes.controls[callCenterQualificacaoQuestao.id].errors?.required) {
                      <div class="erro pt-1">Questão em branco!</div>
                    }
                  </div>
                </div>
              }
              <hr class="mt-2 mb-2" />
              <div class="d-flex flex-wrap justify-content-end">
                <div class="flex-grow-1 text-right">
                  <button class="btn btn-success btn_formulario" type="submit">Salvar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    }
    <!-- Cesta -->
    @if (itemSelecionado == 2) {
      <div [@desvanecer]="'in'">
        <div class="pr-4 pb-4 pl-4">
          <div class="table-responsive">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th class="text-center">Código</th>
                  <th class="tabela_borda">Nome</th>
                  <th class="tabela_borda">Marca</th>
                  <th class="tabela_borda">Aplicação</th>
                  <th class="tabela_borda">Diferencial</th>
                </tr>
              </thead>
              <tbody>
                @for (produtoCesta of produtosCesta; track produtoCesta) {
                  <tr>
                    <td class="text-center">{{ produtoCesta.codigo }}</td>
                    <td class="tabela_borda">{{ produtoCesta.name }}</td>
                    <td class="tabela_borda">{{ produtoCesta.marca }}</td>
                    <td class="tabela_borda">{{ produtoCesta.aplicacao }}</td>
                    <td class="tabela_borda">{{ produtoCesta.diferencial }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }
    <!-- Análise de Vendas -->
    @if (itemSelecionado == 3) {
      <div [@desvanecer]="'in'">
        <div class="pr-4 pb-4 pl-4">
          <!-- Alertas do Cliente -->
          <div class="av_alertas">
            <!-- Dias desde a última compra -->
            <div class="av_alerta_card" [ngClass]="compraForaDoPadrao ? 'av_alerta_danger' : ''">
              <div class="av_alerta_eyebrow">
                Dias desde a última compra
                @if (compraForaDoPadrao) {
                  <span class="av_alerta_badge av_badge_danger">Fora do padrão</span>
                }
              </div>
              <div class="av_alerta_valor">{{ qtdeDiasSemComprar }}<span class="av_alerta_unidade"> dias</span></div>
              <div class="av_alerta_desc">
                @if (intervaloMedioDiasCompra > 0) {
                  Este cliente compra a cada <b>{{ intervaloMedioDiasCompra }} dias</b>, em média{{ compraForaDoPadrao ? (" — já são " + qtdeDiasSemComprar + " dias sem comprar.") : "." }}
                }
                @if (intervaloMedioDiasCompra == 0) {
                  Histórico insuficiente para calcular o padrão de compra deste cliente.
                }
              </div>
            </div>
            <!-- Mês vs. mês anterior -->
            <div class="av_alerta_card" [ngClass]="variacaoMesPercentual != null && variacaoMesPercentual < 0 ? 'av_alerta_danger' : ''">
              <div class="av_alerta_eyebrow">
                Mês vs. mês anterior
                @if (variacaoMesPercentual != null) {
                  <span class="av_alerta_badge" [ngClass]="variacaoMesPercentual >= 0 ? 'av_badge_success' : 'av_badge_danger'">{{ variacaoMesPercentual >= 0 ? 'Crescimento' : 'Queda' }}</span>
                }
              </div>
              <div class="av_alerta_valor" [ngClass]="classeVariacaoPercentual(variacaoMesPercentual)">{{ formatarVariacaoPercentual(variacaoMesPercentual) }}</div>
              <div class="av_alerta_desc">
                {{ valorVendasMesAnterior | currency: 'BRL' }} em {{ nomeMesAnterior }} → <b>{{ valorVendasMesAtual | currency: 'BRL' }}</b> em {{ nomeMesAtual }}.
              </div>
            </div>
            <!-- Oportunidade de resgate -->
            <div class="av_alerta_card" [ngClass]="produtoResgateNome != null ? 'av_alerta_accent' : ''">
              <div class="av_alerta_eyebrow">
                Oportunidade de resgate
                @if (produtoResgateNome != null) {
                  <span class="av_alerta_badge av_badge_accent">Produto sumiu</span>
                }
              </div>
              @if (produtoResgateNome != null) {
                <div class="av_alerta_valor av_alerta_valor_texto">{{ produtoResgateNome }}</div>
                <div class="av_alerta_desc">
                  Presente em <b>{{ produtoResgateFrequencia }} dos últimos {{ produtoResgateTotalPedidosAnteriores }} pedidos</b> (ticket médio {{ produtoResgateTicketMedio | currency: 'BRL' }}) — ausente no pedido mais recente.
                </div>
              }
              @if (produtoResgateNome == null) {
                <div class="av_alerta_valor">—</div>
                <div class="av_alerta_desc">Nenhum produto recorrente ausente identificado no momento.</div>
              }
            </div>
          </div>
          <!-- Vendas por Mês -->
          <div class="av_chart_card mt-3">
            <div class="av_chart_titulo">Vendas por mês</div>
            <div class="av_chart_sub">Últimos 6 meses{{ nomeMesAtual ? (" · " + nomeMesAtual + " ainda em andamento") : "" }}</div>
            @if (vendasMensais6Meses.length > 0) {
              <div class="av_monthly_chart">
                @for (vendaMensal of vendasMensais6Meses; track vendaMensal; let i = $index) {
                  <div class="av_m_col">
                    @if (i == 0) {
                      <div class="av_m_delta">—</div>
                    }
                    @if (i > 0) {
                      <div class="av_m_delta" [ngClass]="classeVariacaoPercentual(vendaMensal.variacao_percentual)">{{ formatarVariacaoPercentual(vendaMensal.variacao_percentual) }}</div>
                    }
                    <div class="av_m_value">{{ vendaMensal.valor | currency: 'BRL' : '' }}</div>
                    <div class="av_m_bar_track">
                      <div class="av_m_bar" [ngClass]="vendaMensal.parcial ? 'av_m_bar_parcial' : ''" [style.height.%]="maiorValorVendaMensal > 0 ? (vendaMensal.valor / maiorValorVendaMensal * 100) : 0"></div>
                    </div>
                    <div class="av_m_label">
                      {{ vendaMensal.mes }}
                      @if (vendaMensal.parcial) {
                        <span class="av_m_tag">parcial</span>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <!-- Vendas por Marca -->
          <div class="av_chart_card mt-3">
            <div class="av_chart_titulo">Vendas por marca</div>
            <div class="av_chart_sub">Participação no faturamento do mês corrente{{ nomeMesAtual ? (" (" + nomeMesAtual + ")") : "" }}</div>
            @if (vendasPorMarcaMesAtual.length == 0) {
              <div class="av_vazio">Nenhuma venda registrada no mês corrente.</div>
            }
            @if (vendasPorMarcaMesAtual.length > 0) {
              <div class="av_brand_chart">
                @for (marca of vendasPorMarcaMesAtual; track marca) {
                  <div class="av_b_row">
                    <div class="av_b_label">{{ marca.marca }}</div>
                    <div class="av_b_track">
                      <div class="av_b_fill" [style.width.%]="vendasPorMarcaMesAtual[0].valor > 0 ? (marca.valor / vendasPorMarcaMesAtual[0].valor * 100) : 0"></div>
                    </div>
                    <div class="av_b_value">{{ marca.valor | currency: 'BRL' }}</div>
                    <div class="av_b_share">{{ marca.percentual | number: '1.0-0' }}%</div>
                  </div>
                }
              </div>
            }
          </div>
          <!-- Top 10 Produtos -->
          <div class="av_chart_card mt-3">
            <div class="av_chart_titulo">Top 10 produtos</div>
            <div class="av_chart_sub">R$ e litros, {{ nomeMesAtual }} comparado a {{ nomeMesAnterior }}</div>
            @if (topProdutosMes.length == 0) {
              <div class="av_vazio">Sem dados suficientes para montar o ranking de produtos.</div>
            }
            @if (topProdutosMes.length > 0) {
              <div class="table-responsive">
                <table class="table table-sm table-hover av_tabela">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Produto</th>
                      <th class="text-right">R$ {{ nomeMesAtual }}</th>
                      <th class="text-right">R$ {{ nomeMesAnterior }}</th>
                      <th class="text-right">Δ R$</th>
                      <th class="text-right">Litros {{ nomeMesAtual }}</th>
                      <th class="text-right">Litros {{ nomeMesAnterior }}</th>
                      <th class="text-right">Δ Litros</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (produto of topProdutosMes; track produto; let i = $index) {
                      <tr>
                        <td><span class="av_rank">{{ i + 1 }}</span></td>
                        <td class="av_td_produto">{{ produto.produto }}</td>
                        <td class="text-right">{{ produto.valor_atual | currency: 'BRL' }}</td>
                        <td class="text-right">{{ produto.valor_anterior | currency: 'BRL' }}</td>
                        <td class="text-right"><span class="av_pill_delta" [ngClass]="produto.variacao_valor_percentual >= 0 ? 'av_pill_up' : 'av_pill_down'">{{ formatarVariacaoPercentual(produto.variacao_valor_percentual) }}</span></td>
                        <td class="text-right">{{ produto.litros_atual | number: '1.0-0' }} L</td>
                        <td class="text-right">{{ produto.litros_anterior | number: '1.0-0' }} L</td>
                        <td class="text-right"><span class="av_pill_delta" [ngClass]="produto.variacao_litros_percentual >= 0 ? 'av_pill_up' : 'av_pill_down'">{{ formatarVariacaoPercentual(produto.variacao_litros_percentual) }}</span></td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
          <!-- Comparativo Trimestral por Produto -->
          <div class="av_chart_card mt-3">
            <div class="av_chart_titulo">Comparativo por produto</div>
            <div class="av_chart_sub">{{ comparativoTrimestralDtInicioRecente | date: 'MMM/yy' }} – {{ comparativoTrimestralDtFimRecente | date: 'MMM/yy' }} × {{ comparativoTrimestralDtInicioAnterior | date: 'MMM/yy' }} – {{ comparativoTrimestralDtFimAnterior | date: 'MMM/yy' }}</div>
            @if (comparativoTrimestralProdutos.length == 0) {
              <div class="av_vazio">Sem dados suficientes para o comparativo trimestral.</div>
            }
            @if (comparativoTrimestralProdutos.length > 0) {
              <div class="table-responsive">
                <table class="table table-sm table-hover av_tabela">
                  <thead>
                    <tr>
                      <th>Produto</th>
                      <th class="text-right">{{ comparativoTrimestralDtInicioRecente | date: 'MMM/yy' }} – {{ comparativoTrimestralDtFimRecente | date: 'MMM/yy' }}</th>
                      <th class="text-right">{{ comparativoTrimestralDtInicioAnterior | date: 'MMM/yy' }} – {{ comparativoTrimestralDtFimAnterior | date: 'MMM/yy' }}</th>
                      <th>Variação</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (produto of comparativoTrimestralProdutos; track produto) {
                      <tr>
                        <td class="av_td_produto">{{ produto.produto }}</td>
                        <td class="text-right">{{ produto.valor_recente | currency: 'BRL' }}</td>
                        <td class="text-right">{{ produto.valor_anterior | currency: 'BRL' }}</td>
                        <td>
                          <div class="av_diverge_cell">
                            <div class="av_diverge_track">
                              <div class="av_diverge_mid"></div>
                              <div class="av_diverge_bar" [ngClass]="produto.variacao_percentual >= 0 ? 'av_diverge_up' : 'av_diverge_down'" [style.width.px]="calcularLarguraDivergente(produto.variacao_percentual)"></div>
                            </div>
                            <span class="av_pill_delta" [ngClass]="produto.variacao_percentual >= 0 ? 'av_pill_up' : 'av_pill_down'">{{ formatarVariacaoPercentual(produto.variacao_percentual) }}</span>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <div class="av_footnote">
                O mês corrente ({{ nomeMesAtual }}, ainda em andamento) fica de fora da conta para não distorcer o resultado — são sempre dois blocos de 3 meses fechados, lado a lado.
              </div>
            }
          </div>
          <!-- Ações -->
          @if (clienteConsultaSelecionadoExterno != 0) {
            <hr class="mt-2 mb-2" />
            <div class="d-flex flex-wrap justify-content-end">
              <button class="btn btn-secondary btn_formulario" type="button" (click)="retornarDashboardOportunidades()">Retornar</button>
            </div>
          }
          @if (clienteConsultaSelecionadoExterno == 0) {
            <hr class="mt-2 mb-2" />
            <div class="d-flex flex-wrap justify-content-end">
              @if (pedidoSelecionadoExterno == 0 && statusSelecionado.id_status != 4 && pedidoNaoEnviadoClienteHoje == null) {
                <button class="btn btn-success btn_formulario" type="button" (click)="novoPedidoOrcamento()">Novo Pedido / Orçamento</button>
              }
              @if (pedidoNaoEnviadoClienteHoje != null) {
                <button class="btn btn-success btn_formulario" type="button" (click)="alterarPedidoOrcamento()">Alterar Pedido / Orçamento</button>
              }
              <button class="btn btn-secondary btn_formulario" type="button" (click)="alterarItemSelecionado(6)">Concluir</button>
            </div>
          }
        </div>
      </div>
    }
    <!-- Histórico de Pedidos / Orçamentos -->
    @if (itemSelecionado == 4) {
      <div [@desvanecer]="'in'">
        <div class="pr-4 pb-4 pl-4">
          <div class="d-flex flex-column">
            <div class="quadro_historico p-2">
              <div class="text-center pb-2">
                <b>Histórico dos Últimos Pedidos / Orçamentos</b>
              </div>
              <div class="d-flex flex-wrap justify-content-between">
                <!-- Última Compra -->
                <div class="quadros_numeros_sm p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-calendar quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ ultimaCompra | date: 'dd/MM/yyyy' }}<br />Última Compra
                    </div>
                  </div>
                </div>
                <!-- Dias sem Comprar -->
                <div class="quadros_numeros_sm p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-asterisk quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ qtdeDiasSemComprar }}<br />Dias sem Comprar
                    </div>
                  </div>
                </div>
                <!-- Ticket Médio -->
                <div class="quadros_numeros_sm p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-dollar quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ valorTicketMedio | currency: 'BRL' }}<br />Ticket Médio
                    </div>
                  </div>
                </div>
                <!-- Objetivo Mensal -->
                <div class="quadros_numeros_sm p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-dollar quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ cliente == null ? 0 : cliente.objetivo_de_venda | currency: 'BRL' : '' }}<br />Objetivo Mensal
                    </div>
                  </div>
                </div>
                <!-- Mês Atual -->
                <div class="quadros_numeros_sm p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2">
                      <i class="fa fa-dollar quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ cliente == null ? 0 : cliente.realizado_venda | currency: 'BRL' : '' }}<br />Mês Atual
                    </div>
                  </div>
                </div>
                <!-- Menor preço -->
                @if (cliente != null && cliente.menor_preco != null) {
                  <div class="quadros_numeros_sm p-2">
                    <div class="d-flex align-items-center">
                      <div class="pl-2">
                        <i class="fa fa-dollar quadros_numeros_icones"></i>
                      </div>
                      <div class="quadros_numeros_textos">
                        {{ cliente == null ? 0 : cliente.menor_preco | currency: 'BRL' : '' }}<br />Menor preço
                      </div>
                    </div>
                  </div>
                }
                <!-- Último prazo -->
                @if (cliente != null && cliente.prazo_principal_vincular != null) {
                  <div class="quadros_numeros_lg p-2 mr-0">
                    <div class="d-flex align-items-center">
                      <div class="pl-2">
                        <i class="fa fa-calendar-check-o quadros_numeros_icones"></i>
                      </div>
                      <div class="quadros_numeros_textos">
                        {{ cliente == null ? '' : cliente.prazo_principal_vincular }}<br />Último prazo
                      </div>
                    </div>
                  </div>
                }
              </div>
              @if (configuracao != null && configuracao.exibe_tabela_historico_pedido && tabelasClientes.length > 0) {
                <hr class="mt-2 mb-2" />
                <div class="pb-2 text-center">
                  <b>Tabela(s) Vinculada(s)</b>
                </div>
                <div class="table-responsive">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th>Descrição</th>
                        <th class="tabela_borda">Nome</th>
                        <th class="text-right tabela_borda">Valor: R$</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (tabelaCliente of tabelasClientes; track tabelaCliente) {
                        <tr>
                          <td>{{ tabelaCliente.descricao }}</td>
                          <td class="tabela_borda">{{ tabelaCliente.nome }}</td>
                          <td class="text-right tabela_borda">{{ tabelaCliente.preco | currency: 'BRL' }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
                <hr class="mt-2 mb-2" />
              }
              <ul ngbNav #t="ngbNav" class="nav-tabs">
                <!-- Pedidos Enviados (Cliente) -->
                <li [ngbNavItem]="'tab-enviados'">
                  <a ngbNavLink>
                    <b>Enviados</b>
                  </a>
                  <ng-template ngbNavContent>
                    <div class="bg-white pt-3">
        @if (modelo_tela_ligacoes == 0) {
                        <!-- Modelo 1 -->
                        <div class="table-responsive">
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <th></th>
                                <th class="text-center tabela_borda">Status</th>
                                <th class="text-center tabela_borda">Nro Pedido</th>
                                <th class="text-center tabela_borda">Nro (ERP)</th>
                                <th class="tabela_borda">Vend Externo</th>
                                <th class="tabela_borda">Vend Interno</th>
                                <th class="tabela_borda">Cliente</th>
                                <th class="text-right tabela_borda">Total: R$</th>
                                <th class="text-right tabela_borda">Litragem</th>
                                <th class="text-center tabela_borda">Enviado</th>
                                <th class="text-center tabela_borda">Pedido Programado</th>
                                <th class="tabela_borda">Prazo Pagto</th>
                                <th class="text-center tabela_borda">Tipo</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (pedidoEnviadoCliente of pedidosEnviadosClientes; track pedidoEnviadoCliente; let i = $index) {
                                <tr>
                                  <td class="text-center tabela_acao">
                                    <i class="fa  btn_tabela_acao" [ngClass]="i == pedidosItensEnviadosExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirPedidosItensEnviados(i, pedidoEnviadoCliente.order_id_app)"></i>
                                    <ng-container *ngTemplateOutlet="enviarPdfAnalise; context: { $implicit: pedidoEnviadoCliente }"></ng-container>
                                  </td>
                                  <td class="text-center tabela_borda">
                                    @if (pedidoEnviadoCliente.status_pedido == 'À Integrar') {
                                      <span class="badge badge-primary">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Aguard Aprov') {
                                      <span class="badge badge-warning">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Aguard Cad') {
                                      <span class="badge badge-secondary">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Cancelado') {
                                      <span class="badge badge-distinct">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Erro Integ') {
                                      <span class="badge badge-danger">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Faturado') {
                                      <span class="badge badge-info">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Faturado Div') {
                                      <span class="badge badge-other">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Integrado') {
                                      <span class="badge badge-success">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Reprovado') {
                                      <span class="badge badge-dark">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                  </td>
                                  <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.order_id_app }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.id_no_erp_do_cliente }}</td>
                                  <td class="tabela_borda">{{ pedidoEnviadoCliente.vend_ext }}</td>
                                  <td class="tabela_borda">{{ pedidoEnviadoCliente.vend_int }}</td>
                                  <td class="tabela_borda">{{ pedidoEnviadoCliente.name }}</td>
                                  <td class="text-right tabela_borda">{{ pedidoEnviadoCliente.total | currency: 'BRL' }}</td>
                                  <td class="text-right tabela_borda">{{ pedidoEnviadoCliente.total_litragem | currency: 'BRL' : '' }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.order_sent_on | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.dt_previsao_entrega | date: 'dd/MM/yyyy' }}</td>
                                  <td class="tabela_borda">{{ pedidoEnviadoCliente.prazo_pgto }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.cod_tipopedvenda }}</td>
                                </tr>
                                @if (i == pedidosItensEnviadosExpandido) {
                                  <tr [@esvanecerDesvanecer]="'in'">
                                    <td class="p-3" colspan="13">
                                      <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                                        <table class="table table-sm table-hover">
                                          <thead>
                                            <tr>
                                              <th class="text-center">Código</th>
                                              <th class="tabela_borda">Descrição</th>
                                              <th class="text-center tabela_borda">Qtde</th>
                                              <th class="text-right tabela_borda">Unitário: R$</th>
                                              @if (exibirFatorFinanceiroEnviados) {
                                                <th class="text-right tabela_borda">Fator: R$</th>
                                              }
                                              @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                                <th class="text-right tabela_borda">Imposto: R$</th>
                                              }
                                              @if (exibirFatorFinanceiroEnviados || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                                <th class="text-right tabela_borda">Unitário (Final): R$</th>
                                              }
                                              <th class="text-right tabela_borda">Sub-Total: R$</th>
                                              @if (is_master || is_manager || is_diretor) {
                                                <th class="text-right tabela_borda">Margem: %</th>
                                              }
                                              <th class="text-right tabela_borda">Tabela: R$</th>
                                              <th class="tabela_borda">Observação</th>
                                              <th class="text-right tabela_borda">Desconto: R$</th>
                                              <th class="text-right tabela_borda">Desconto: %</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <ng-container *cdkVirtualFor="let pedidoItemEnviado of pedidosItensEnviados; templateCacheSize: 0;">
                                              <tr>
                                                <td class="text-center">{{ pedidoItemEnviado.referencia_cliente }}</td>
                                                <td class="tabela_borda">{{ pedidoItemEnviado.produto }}</td>
                                                <td class="text-center tabela_borda">{{ pedidoItemEnviado.quantity }}</td>
                                                <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(pedidoItemEnviado.vr_unitario_original) }}</td>
                                                @if (exibirFatorFinanceiroEnviados) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemEnviado.fator_financeiro | currency: 'BRL' }}</td>
                                                }
                                                @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemEnviado.valor_imposto | currency: 'BRL' }}</td>
                                                }
                                                @if (exibirFatorFinanceiroEnviados || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemEnviado.vr_unitario_acumulado | currency: 'BRL' }}</td>
                                                }
                                                <td class="text-right tabela_borda">{{ pedidoItemEnviado.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                                                @if (is_master || is_manager || is_diretor) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemEnviado.mkt | currency: 'BRL' : '' }}%</td>
                                                }
                                                @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemEnviado.preco_tabela | currency: 'BRL' }}</td>
                                                }
                                                @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemEnviado.precotabela2 | currency: 'BRL' }}</td>
                                                }
                                                <td class="tabela_borda">{{ pedidoItemEnviado.descritivo_desconto }}</td>
                                                <td class="text-right tabela_borda">{{ pedidoItemEnviado.valor_desconto | currency: 'BRL' }}</td>
                                                @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemEnviado.desc_aplicado | currency: 'BRL' : '' }}%</td>
                                                }
                                                @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemEnviado.desc_aplicado2 | currency: 'BRL' : '' }}%</td>
                                                }
                                              </tr>
                                              @if (configuracao != null && configuracao.flag_exibe_observacao_item_pedido && pedidoItemEnviado.observacao_item != null && pedidoItemEnviado.observacao_item != '') {
                                                <tr>
                                                  <td></td>
                                                  <td class="tabela_borda" colspan="13">
                                                    {{ pedidoItemEnviado.observacao_item }}
                                                  </td>
                                                </tr>
                                              }
                                            </ng-container>
                                          </tbody>
                                          <tfoot>
                                            @if (pedidoEnviadoCliente.observacao_interna != null && pedidoEnviadoCliente.observacao_interna != '') {
                                              <tr>
                                                <td class="tabela_itens_observacao" colspan="13"><b>Observação Interna:</b> {{ pedidoEnviadoCliente.observacao_interna }}</td>
                                              </tr>
                                            }
                                            @if (pedidoEnviadoCliente.observacao_nf != null && pedidoEnviadoCliente.observacao_nf != '') {
                                              <tr>
                                                <td class="tabela_itens_observacao" colspan="13"><b>Observação Nota Fiscal:</b> {{ pedidoEnviadoCliente.observacao_nf }}</td>
                                              </tr>
                                            }
                                          </tfoot>
                                        </table>
                                      </cdk-virtual-scroll-viewport>
                                    </td>
                                  </tr>
                                }
                              }
                            </tbody>
                          </table>
                        </div>
                      }
                      @if (modelo_tela_ligacoes == 1) {
                        <!-- Modelo 2 -->
                        <div class="table-responsive">
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <th></th>
                                <th class="text-center tabela_borda">Status</th>
                                <th class="text-center tabela_borda">Nro Pedido</th>
                                <th class="tabela_borda">Cliente</th>
                                <th class="text-right tabela_borda">Total: R$</th>
                                <th class="text-right tabela_borda">Volume Total: R$</th>
                                <th class="text-center tabela_borda">Data do Pedido</th>
                                <th class="tabela_borda">Prazo Pagto</th>
                                <th class="text-center tabela_borda">Tipo</th>
                                <th class="text-center tabela_borda">Nota Fiscal</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (pedidoEnviadoCliente of pedidosEnviadosClientes; track pedidoEnviadoCliente; let i = $index) {
                                <tr>
                                  <td class="text-center tabela_acao">
                                    <i class="fa  btn_tabela_acao" [ngClass]="i == pedidosItensEnviadosExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirPedidosItensEnviados(i, pedidoEnviadoCliente.order_id_app)"></i>
                                    <ng-container *ngTemplateOutlet="enviarPdfAnalise; context: { $implicit: pedidoEnviadoCliente }"></ng-container>
                                  </td>
                                  <td class="text-center tabela_borda">
                                    @if (pedidoEnviadoCliente.status_pedido == 'À Integrar') {
                                      <span class="badge badge-primary">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Aguard Aprov') {
                                      <span class="badge badge-warning">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Aguard Cad') {
                                      <span class="badge badge-secondary">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Cancelado') {
                                      <span class="badge badge-distinct">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Erro Integ') {
                                      <span class="badge badge-danger">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Faturado') {
                                      <span class="badge badge-info">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Faturado Div') {
                                      <span class="badge badge-other">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Integrado') {
                                      <span class="badge badge-success">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoEnviadoCliente.status_pedido == 'Reprovado') {
                                      <span class="badge badge-dark">{{ pedidoEnviadoCliente.status_pedido }}</span>
                                    }
                                  </td>
                                  <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.id_no_erp_do_cliente }}</td>
                                  <td class="tabela_borda">{{ pedidoEnviadoCliente.name }}</td>
                                  <td class="text-right tabela_borda">{{ pedidoEnviadoCliente.total | currency: 'BRL' }}</td>
                                  <td class="text-right tabela_borda">{{ pedidoEnviadoCliente.total_volume | currency: 'BRL' }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.order_created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                  <td class="tabela_borda">{{ pedidoEnviadoCliente.prazo_pgto }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.cod_tipopedvenda }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoEnviadoCliente.numero_nf }}</td>
                                </tr>
                                @if (i == pedidosItensEnviadosExpandido) {
                                  <tr [@esvanecerDesvanecer]="'in'">
                                    <td class="p-3" colspan="10">
                                      <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                                        <table class="table table-sm table-hover">
                                          <thead>
                                            <tr>
                                              <th class="text-center">Código</th>
                                              <th class="text-center tabela_borda">Sku</th>
                                              <th class="tabela_borda">Descrição</th>
                                              <th class="tabela_borda">Marca</th>
                                              <th class="text-center tabela_borda">Qtde</th>
                                              <th class="text-right tabela_borda">Unitário: R$</th>
                                              <th class="text-right tabela_borda">Total: R$</th>
                                              <th class="text-right tabela_borda">Volume: R$</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <ng-container *cdkVirtualFor="let pedidoItemEnviado of pedidosItensEnviados; templateCacheSize: 0;">
                                              <tr>
                                                <td class="text-center">{{ pedidoItemEnviado.codigo }}</td>
                                                <td class="text-center tabela_borda">{{ pedidoItemEnviado.referencia_cliente }}</td>
                                                <td class="tabela_borda">{{ pedidoItemEnviado.produto }}</td>
                                                <td class="tabela_borda">{{ pedidoItemEnviado.grupo_estoque }}</td>
                                                <td class="text-center tabela_borda">{{ pedidoItemEnviado.quantity }}</td>
                                                <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(pedidoItemEnviado.vr_unitario_original) }}</td>
                                                <td class="text-right tabela_borda">{{ pedidoItemEnviado.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                                                <td class="text-right tabela_borda">{{ pedidoItemEnviado.volume | currency: 'BRL' }}</td>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                          <tfoot>
                                            @if (pedidoEnviadoCliente.observacao_interna != null && pedidoEnviadoCliente.observacao_interna != '') {
                                              <tr>
                                                <td class="tabela_itens_observacao" colspan="8"><b>Observação Interna:</b> {{ pedidoEnviadoCliente.observacao_interna }}</td>
                                              </tr>
                                            }
                                            @if (pedidoEnviadoCliente.observacao_nf != null && pedidoEnviadoCliente.observacao_nf != '') {
                                              <tr>
                                                <td class="tabela_itens_observacao" colspan="8"><b>Observação Nota Fiscal:</b> {{ pedidoEnviadoCliente.observacao_nf }}</td>
                                              </tr>
                                            }
                                          </tfoot>
                                        </table>
                                      </cdk-virtual-scroll-viewport>
                                    </td>
                                  </tr>
                                }
                              }
                            </tbody>
                          </table>
                        </div>
                      }
                    </div>
                  </ng-template>
                </li>
                <!-- Pedidos Não Enviados (Cliente) -->
                <li [ngbNavItem]="'tab-nao-enviados'">
                  <a ngbNavLink>
                    <b>Não Enviados</b>
                  </a>
                  <ng-template ngbNavContent>
                    <div class="bg-white pt-3">
                      @if (modelo_tela_ligacoes == 0) {
                        <!-- Modelo 1 -->
                        <div class="table-responsive">
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <th></th>
                                <th class="text-center tabela_borda">Status</th>
                                <th class="text-center tabela_borda">Nro Pedido</th>
                                <th class="tabela_borda">Vend Externo</th>
                                <th class="tabela_borda">Vend Interno</th>
                                <th class="tabela_borda">Cliente</th>
                                <th class="text-right tabela_borda">Total: R$</th>
                                <th class="text-right tabela_borda">Litragem</th>
                                <th class="text-center tabela_borda">Criado</th>
                                <th class="tabela_borda">Prazo Pagto</th>
                                <th class="text-center tabela_borda">Tipo</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (pedidoNaoEnviadoCliente of pedidosNaoEnviadosClientes; track pedidoNaoEnviadoCliente; let i = $index) {
                                <tr>
                                  <td class="text-center tabela_acao">
                                    <i class="fa  btn_tabela_acao" [ngClass]="i == pedidosItensNaoEnviadosExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirPedidosItensNaoEnviados(i, pedidoNaoEnviadoCliente.order_id_app)"></i>
                                    <ng-container *ngTemplateOutlet="enviarPdfAnalise; context: { $implicit: pedidoNaoEnviadoCliente }"></ng-container>
                                  </td>
                                  <td class="text-center tabela_borda">
                                    @if (pedidoNaoEnviadoCliente.status_pedido == 'Orçamento') {
                                      <span class="badge badge-warning">{{ pedidoNaoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoNaoEnviadoCliente.status_pedido == 'Não Enviado') {
                                      <span class="badge badge-primary">{{ pedidoNaoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoNaoEnviadoCliente.status_pedido == 'Reprovado') {
                                      <span class="badge badge-dark">{{ pedidoNaoEnviadoCliente.status_pedido }}</span>
                                    }
                                  </td>
                                  <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.order_id_app }}</td>
                                  <td class="tabela_borda">{{ pedidoNaoEnviadoCliente.vend_ext }}</td>
                                  <td class="tabela_borda">{{ pedidoNaoEnviadoCliente.vend_int }}</td>
                                  <td class="tabela_borda">{{ pedidoNaoEnviadoCliente.name }}</td>
                                  <td class="text-right tabela_borda">{{ pedidoNaoEnviadoCliente.total | currency: 'BRL' }}</td>
                                  <td class="text-right tabela_borda">{{ pedidoNaoEnviadoCliente.total_litragem | currency: 'BRL' : '' }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.order_created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                  <td class="tabela_borda">{{ pedidoNaoEnviadoCliente.prazo_pgto }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.cod_tipopedvenda }}</td>
                                </tr>
                                @if (i == pedidosItensNaoEnviadosExpandido) {
                                  <tr [@esvanecerDesvanecer]="'in'">
                                    <td class="p-3" colspan="11">
                                      <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                                        <table class="table table-sm table-hover">
                                          <thead>
                                            <tr>
                                              <th class="text-center">Código</th>
                                              <th class="tabela_borda">Descrição</th>
                                              <th class="text-center tabela_borda">Qtde</th>
                                              <th class="text-right tabela_borda">Unitário: R$</th>
                                              @if (exibirFatorFinanceiroNaoEnviados) {
                                                <th class="text-right tabela_borda">Fator: R$</th>
                                              }
                                              @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                                <th class="text-right tabela_borda">Imposto: R$</th>
                                              }
                                              @if (exibirFatorFinanceiroNaoEnviados || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                                <th class="text-right tabela_borda">Unitário (Final): R$</th>
                                              }
                                              <th class="text-right tabela_borda">Sub-Total: R$</th>
                                              @if (is_master || is_manager || is_diretor) {
                                                <th class="text-right tabela_borda">Margem: %</th>
                                              }
                                              <th class="text-right tabela_borda">Tabela: R$</th>
                                              <th class="tabela_borda">Observação</th>
                                              <th class="text-right tabela_borda">Desconto: R$</th>
                                              <th class="text-right tabela_borda">Desconto: %</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <ng-container *cdkVirtualFor="let pedidoItemNaoEnviado of pedidosItensNaoEnviados; templateCacheSize: 0;">
                                              <tr>
                                                <td class="text-center">{{ pedidoItemNaoEnviado.referencia_cliente }}</td>
                                                <td class="tabela_borda">{{ pedidoItemNaoEnviado.produto }}</td>
                                                <td class="text-center tabela_borda">{{ pedidoItemNaoEnviado.quantity }}</td>
                                                <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(pedidoItemNaoEnviado.vr_unitario_original) }}</td>
                                                @if (exibirFatorFinanceiroNaoEnviados) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.fator_financeiro | currency: 'BRL' }}</td>
                                                }
                                                @if (configuracao != null && configuracao.flag_exibir_imposto_produto) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.valor_imposto | currency: 'BRL' }}</td>
                                                }
                                                @if (exibirFatorFinanceiroNaoEnviados || (configuracao != null && configuracao.flag_exibir_imposto_produto)) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.vr_unitario_acumulado | currency: 'BRL' }}</td>
                                                }
                                                <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                                                @if (is_master || is_manager || is_diretor) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.mkt | currency: 'BRL' : '' }}%</td>
                                                }
                                                @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.preco_tabela | currency: 'BRL' }}</td>
                                                }
                                                @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.precotabela2 | currency: 'BRL' }}</td>
                                                }
                                                <td class="tabela_borda">{{ pedidoItemNaoEnviado.descritivo_desconto }}</td>
                                                <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.valor_desconto | currency: 'BRL' }}</td>
                                                @if (configuracao != null && !configuracao.exibe_price_como_tabela_pedidos) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.desc_aplicado | currency: 'BRL' : '' }}%</td>
                                                }
                                                @if (configuracao != null && configuracao.exibe_price_como_tabela_pedidos) {
                                                  <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.desc_aplicado2 | currency: 'BRL' : '' }}%</td>
                                                }
                                              </tr>
                                              @if (configuracao != null && configuracao.flag_exibe_observacao_item_pedido && pedidoItemNaoEnviado.observacao_item != null && pedidoItemNaoEnviado.observacao_item != '') {
                                                <tr>
                                                  <td></td>
                                                  <td class="tabela_borda" colspan="14">
                                                    {{ pedidoItemNaoEnviado.observacao_item }}
                                                  </td>
                                                </tr>
                                              }
                                            </ng-container>
                                          </tbody>
                                          <tfoot>
                                            @if (pedidoNaoEnviadoCliente.observacao_interna != null && pedidoNaoEnviadoCliente.observacao_interna != '') {
                                              <tr>
                                                <td class="tabela_itens_observacao" colspan="15"><b>Observação Interna:</b> {{ pedidoNaoEnviadoCliente.observacao_interna }}</td>
                                              </tr>
                                            }
                                            @if (pedidoNaoEnviadoCliente.observacao_nf != null && pedidoNaoEnviadoCliente.observacao_nf != '') {
                                              <tr>
                                                <td class="tabela_itens_observacao" colspan="15"><b>Observação Nota Fiscal:</b> {{ pedidoNaoEnviadoCliente.observacao_nf }}</td>
                                              </tr>
                                            }
                                          </tfoot>
                                        </table>
                                      </cdk-virtual-scroll-viewport>
                                    </td>
                                  </tr>
                                }
                              }
                            </tbody>
                          </table>
                        </div>
                      }
                      @if (modelo_tela_ligacoes == 1) {
                        <!-- Modelo 2 -->
                        <div class="table-responsive">
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <th></th>
                                <th class="text-center tabela_borda">Status</th>
                                <th class="text-center tabela_borda">Nro Pedido</th>
                                <th class="tabela_borda">Cliente</th>
                                <th class="text-right tabela_borda">Total: R$</th>
                                <th class="text-right tabela_borda">Volume Total: R$</th>
                                <th class="text-center tabela_borda">Data do Pedido</th>
                                <th class="tabela_borda">Prazo Pagto</th>
                                <th class="text-center tabela_borda">Tipo</th>
                                <th class="text-center tabela_borda">Nota Fiscal</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (pedidoNaoEnviadoCliente of pedidosNaoEnviadosClientes; track pedidoNaoEnviadoCliente; let i = $index) {
                                <tr>
                                  <td class="text-center tabela_acao">
                                    <i class="fa  btn_tabela_acao" [ngClass]="i == pedidosItensNaoEnviadosExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirPedidosItensNaoEnviados(i, pedidoNaoEnviadoCliente.order_id_app)"></i>
                                    <ng-container *ngTemplateOutlet="enviarPdfAnalise; context: { $implicit: pedidoNaoEnviadoCliente }"></ng-container>
                                  </td>
                                  <td class="text-center tabela_borda">
                                    @if (pedidoNaoEnviadoCliente.status_pedido == 'Orçamento') {
                                      <span class="badge badge-warning">{{ pedidoNaoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoNaoEnviadoCliente.status_pedido == 'Não Enviado') {
                                      <span class="badge badge-primary">{{ pedidoNaoEnviadoCliente.status_pedido }}</span>
                                    }
                                    @if (pedidoNaoEnviadoCliente.status_pedido == 'Reprovado') {
                                      <span class="badge badge-dark">{{ pedidoNaoEnviadoCliente.status_pedido }}</span>
                                    }
                                  </td>
                                  <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.id_no_erp_do_cliente }}</td>
                                  <td class="tabela_borda">{{ pedidoNaoEnviadoCliente.name }}</td>
                                  <td class="text-right tabela_borda">{{ pedidoNaoEnviadoCliente.total | currency: 'BRL' }}</td>
                                  <td class="text-right tabela_borda">{{ pedidoNaoEnviadoCliente.total_volume | currency: 'BRL' }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.order_created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                  <td class="tabela_borda">{{ pedidoNaoEnviadoCliente.prazo_pgto }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.cod_tipopedvenda }}</td>
                                  <td class="text-center tabela_borda">{{ pedidoNaoEnviadoCliente.numero_nf }}</td>
                                </tr>
                                @if (i == pedidosItensNaoEnviadosExpandido) {
                                  <tr [@esvanecerDesvanecer]="'in'">
                                    <td class="p-3" colspan="10">
                                      <cdk-virtual-scroll-viewport class="tabela_sm" [itemSize]="20">
                                        <table class="table table-sm table-hover">
                                          <thead>
                                            <tr>
                                              <th class="text-center">Código</th>
                                              <th class="text-center tabela_borda">Sku</th>
                                              <th class="tabela_borda">Descrição</th>
                                              <th class="tabela_borda">Marca</th>
                                              <th class="text-center tabela_borda">Qtde</th>
                                              <th class="text-right tabela_borda">Unitário: R$</th>
                                              <th class="text-right tabela_borda">Total: R$</th>
                                              <th class="text-right tabela_borda">Volume: R$</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <ng-container *cdkVirtualFor="let pedidoItemNaoEnviado of pedidosItensNaoEnviados; templateCacheSize: 0;">
                                              <tr>
                                                <td class="text-center">{{ pedidoItemNaoEnviado.codigo }}</td>
                                                <td class="text-center tabela_borda">{{ pedidoItemNaoEnviado.referencia_cliente }}</td>
                                                <td class="tabela_borda">{{ pedidoItemNaoEnviado.produto }}</td>
                                                <td class="tabela_borda">{{ pedidoItemNaoEnviado.grupo_estoque }}</td>
                                                <td class="text-center tabela_borda">{{ pedidoItemNaoEnviado.quantity }}</td>
                                                <td class="text-right tabela_borda">{{ formatarValoresQuatroCasasDecimais(pedidoItemNaoEnviado.vr_unitario_original) }}</td>
                                                <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.vr_sub_total_acumulado | currency: 'BRL' }}</td>
                                                <td class="text-right tabela_borda">{{ pedidoItemNaoEnviado.volume | currency: 'BRL' }}</td>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                          <tfoot>
                                            @if (pedidoNaoEnviadoCliente.observacao_interna != null && pedidoNaoEnviadoCliente.observacao_interna != '') {
                                              <tr>
                                                <td class="tabela_itens_observacao" colspan="8"><b>Observação Interna:</b> {{ pedidoNaoEnviadoCliente.observacao_interna }}</td>
                                              </tr>
                                            }
                                            @if (pedidoNaoEnviadoCliente.observacao_nf != null && pedidoNaoEnviadoCliente.observacao_nf != '') {
                                              <tr>
                                                <td class="tabela_itens_observacao" colspan="8"><b>Observação Nota Fiscal:</b> {{ pedidoNaoEnviadoCliente.observacao_nf }}</td>
                                              </tr>
                                            }
                                          </tfoot>
                                        </table>
                                      </cdk-virtual-scroll-viewport>
                                    </td>
                                  </tr>
                                }
                              }
                            </tbody>
                          </table>
                        </div>
                      }
                    </div>
                  </ng-template>
                </li>
              </ul>
              <div [ngbNavOutlet]="t"></div>
              <div class="col-sm-12 text-right p-2">
                <button class="btn btn-link" type="button" (click)="exportarHistoricoUltimosPedidos()">Exportar p/ Excel</button>
              </div>
            </div>
          </div>
          <!-- Ações -->
          @if (clienteConsultaSelecionadoExterno != 0) {
            <hr class="mt-2 mb-2" />
            <div class="d-flex flex-wrap justify-content-end">
              <button class="btn btn-secondary btn_formulario" type="button" (click)="retornarDashboardOportunidades()">Retornar</button>
            </div>
          }
          @if (clienteConsultaSelecionadoExterno == 0) {
            <hr class="mt-2 mb-2" />
            <div class="d-flex flex-wrap justify-content-end">
              @if (pedidoSelecionadoExterno == 0 && statusSelecionado.id_status != 4 && pedidoNaoEnviadoClienteHoje == null) {
                <button class="btn btn-success btn_formulario" type="button" (click)="novoPedidoOrcamento()">Novo Pedido / Orçamento</button>
              }
              @if (pedidoNaoEnviadoClienteHoje != null) {
                <button class="btn btn-success btn_formulario" type="button" (click)="alterarPedidoOrcamento()">Alterar Pedido / Orçamento</button>
              }
              <button class="btn btn-secondary btn_formulario" type="button" (click)="alterarItemSelecionado(6)">Concluir</button>
            </div>
          }
        </div>
      </div>
    }
    <!-- Histórico de Contatos -->
    @if (itemSelecionado == 5) {
      <div [@desvanecer]="'in'">
        <div class="pr-4 pb-4 pl-4">
          <div class="d-flex flex-column">
            <div class="text-center pb-2">
              <b>Histórico de Contatos</b>
            </div>

            <!-- WhatsApp -->
            <div class="quadro_historico p-2 mb-3">
              <div class="text-center pb-2">
                <b><i class="fa fa-whatsapp historico_icone_whatsapp"></i> WhatsApp</b>
              </div>
              <div class="d-flex flex-wrap justify-content-between">
                <!-- Última mensagem -->
                <div class="quadros_numeros_sm p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-calendar quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ ultimaMensagemWhatsApp | date: 'dd/MM/yyyy' }}<br />Última Mensagem
                    </div>
                  </div>
                </div>
                <!-- Atendimentos -->
                <div class="quadros_numeros_sm p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-list-alt quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ qtdeAtendimentosWhatsApp }}<br />Atendimentos
                    </div>
                  </div>
                </div>
                <!-- Motivo de Perda Mais Frequente -->
                <div class="flex-grow-1 quadros_numeros_sm p-2 mr-0">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-tags quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ motivoPerdaMaisFrequenteWhatsApp || '—' }}<br />Motivo de Perda Mais Frequente
                    </div>
                  </div>
                </div>
              </div>
              <div class="bg-white">
                <div class="table-responsive">
                  <table class="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th></th>
                        <th class="tabela_borda">Vendedor(a)</th>
                        <th class="text-center tabela_borda">1ª Mensagem</th>
                        <th class="text-center tabela_borda">Início Atend.</th>
                        <th class="text-center tabela_borda">Finalização</th>
                        <th class="tabela_borda">Etapa</th>
                        <th class="text-center tabela_borda">Tipo</th>
                        <th class="tabela_borda">Resultado</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (atendimento of atendimentosWhatsApp; track atendimento; let i = $index) {
                        <tr>
                          <td class="text-center tabela_acao">
                            @if (i == 0) {
                              <button
                                class="btn btn-link p-0 whatsapp-oficial-atalho"
                                type="button"
                                placement="right"
                                ngbTooltip="Abrir atendimento"
                                [disabled]="whatsappOficialAbrindo"
                                (click)="abrirAtendimentoWhatsAppHistorico(whatsappOficialAtendimento, atendimento.id)">
                                <i class="fa fa-whatsapp"></i>
                              </button>
                            }
                          </td>
                          <td class="tabela_borda">{{ atendimento.seller_nome_atual || '—' }}</td>
                          <td class="text-center tabela_borda">{{ atendimento.dt_primeira_mensagem | date: 'dd/MM/yy HH:mm' }}</td>
                          <td class="text-center tabela_borda">{{ atendimento.dt_inicio_atendimento | date: 'dd/MM/yy HH:mm' }}</td>
                          <td class="text-center tabela_borda">{{ atendimento.dt_finalizacao | date: 'dd/MM/yy HH:mm' }}</td>
                          <td class="tabela_borda">{{ atendimento.etapa_nome }}</td>
                          <td class="text-center tabela_borda">
                            <span class="badge_etapa_tipo" [ngClass]="'badge_etapa_tipo_' + (atendimento.etapa_tipo | lowercase)">{{ atendimento.etapa_tipo }}</span>
                          </td>
                          <td class="tabela_borda">
                            @if (atendimento.etapa_tipo == 'PERDA') {
                              <span>{{ atendimento.motivo_perda_nome }}</span>
                              @if (atendimento.motivo_perda_complemento) {
                                <small class="d-block text-muted">{{ atendimento.motivo_perda_complemento }}</small>
                              }
                            } @else {
                              <span>—</span>
                            }
                          </td>
                        </tr>
                      }
                      @if (atendimentosWhatsApp.length == 0) {
                        <tr>
                          <td class="tabela_borda text-center text-muted" colspan="8">Nenhum atendimento de WhatsApp encontrado.</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Ligações -->
            <div class="quadro_historico p-2">
              <div class="text-center pb-2">
                <b><i class="fa fa-phone"></i> Ligações</b>
              </div>
              <div class="d-flex flex-wrap justify-content-between">
                <!-- Última Ligação -->
                <div class="quadros_numeros_sm p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-calendar quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ ultimaVisita | date: 'dd/MM/yyyy' }}<br />Última Ligação
                    </div>
                  </div>
                </div>
                <!-- Dias sem Ligação -->
                <div class="quadros_numeros_sm p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-asterisk quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ qtdeDiasSemVisita }}<br />Dias sem Ligação
                    </div>
                  </div>
                </div>
                <!-- Resultado c/ Maior Frequência -->
                <div class="flex-grow-1 quadros_numeros_sm p-2 mr-0">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-tags quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ resultadoComMaiorFrequencia }}<br />Resultado c/ Maior Frequência
                    </div>
                  </div>
                </div>
              </div>
              <div class="bg-white">
                <div class="table-responsive">
                  <table class="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th></th>
                        <th class="tabela_borda">Vendedor(a)</th>
                        <th class="text-center tabela_borda">Check-in</th>
                        <th class="tabela_borda">Resultado</th>
                        <th class="tabela_borda">Observação</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (visita of visitas; track visita) {
                        <tr>
                          <td class="text-center tabela_acao">
                            <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="modalAlterarVisita(alterarVisita, visita.id)"></i>
                          </td>
                          <td class="tabela_borda">{{ visita.fullname }}</td>
                          <td class="text-center tabela_borda">{{ visita.check_in | date: 'dd/MM/yyyy' }}</td>
                          <td class="tabela_borda">{{ visita.name }}</td>
                          <td class="tabela_borda">{{ visita.note }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-sm-12 text-right p-2">
                <button class="btn btn-link" type="button" (click)="exportarHistoricoLigacoes()">Exportar p/ Excel</button>
              </div>
            </div>
          </div>
          <!-- Ações -->
          @if (clienteConsultaSelecionadoExterno != 0) {
            <hr class="mt-2 mb-2" />
            <div class="d-flex flex-wrap justify-content-end">
              <button class="btn btn-secondary btn_formulario" type="button" (click)="retornarDashboardOportunidades()">Retornar</button>
            </div>
          }
          @if (clienteConsultaSelecionadoExterno == 0) {
            <hr class="mt-2 mb-2" />
            <div class="d-flex flex-wrap justify-content-end">
              @if (pedidoSelecionadoExterno == 0 && statusSelecionado.id_status != 4 && pedidoNaoEnviadoClienteHoje == null) {
                <button class="btn btn-success btn_formulario" type="button" (click)="novoPedidoOrcamento()">Novo Pedido / Orçamento</button>
              }
              @if (pedidoNaoEnviadoClienteHoje != null) {
                <button class="btn btn-success btn_formulario" type="button" (click)="alterarPedidoOrcamento()">Alterar Pedido / Orçamento</button>
              }
              <button class="btn btn-secondary btn_formulario" type="button" (click)="alterarItemSelecionado(6)">Concluir</button>
            </div>
          }
        </div>
      </div>
    }
    <!-- Concluir Ligação -->
    @if (itemSelecionado == 6) {
      <div [@desvanecer]="'in'">
        <div class="pr-4 pb-4 pl-4">
          <!-- Formulário -->
          <div class="form-row">
            <div class="form-group" [ngClass]="statusSelecionado.id_status != 1 && statusSelecionado.id_status != 4 && statusSelecionado.id_status != 5 ? 'col-sm-5' : 'col-sm-6'">
              <label><b>Status:</b></label>
              <select class="form-control form-control-sm" name="statusLigacao" #statusLigacao (change)="selecionarStatus(statusLigacao.value)" [disabled]="statusSelecionado.id_status == 4 && (!callCenterConfiguracao.libera_status_vendarealizada || pedidoSelecionadoExternoComVendaRealizada)">
                @for (opcao of status; track opcao) {
                  <option [value]="opcao.id" [selected]="statusSelecionado != null ? opcao.id == statusSelecionado.id : null" [hidden]="opcao.id == 1 || opcao.id == 6 || (opcao.id == 4 && !pedidoSelecionadoExternoComVendaRealizada && !callCenterConfiguracao.libera_status_vendarealizada)">{{ opcao.name }}</option>
                }
              </select>
            </div>
            @if (statusSelecionado.id_status != 1 && statusSelecionado.id_status != 4 && statusSelecionado.id_status != 5) {
              <div class="form-group col-sm-2">
                <label><b>Hora:</b></label>
                <ngb-timepicker name="ligacao_hora_atual" [spinners]="false" [(ngModel)]="ligacaoHoraAtual"></ngb-timepicker>
              </div>
            }
            @if (statusSelecionado.id_status != 4) {
              <div class="form-group" [ngClass]="statusSelecionado.id_status != 1 && statusSelecionado.id_status != 4 && statusSelecionado.id_status != 5 ? 'col-sm-5' : 'col-sm-6'">
                <label><b>Resultado:</b></label>
                <select class="form-control form-control-sm" name="resultado" #resultado (change)="selecionarResultado(resultado.value)">
                  @for (opcao of resultados; track opcao) {
                    <option [value]="opcao.id" [selected]="resultadoSelecionado != null ? opcao.id == resultadoSelecionado.id : null">{{ opcao.name }}</option>
                  }
                </select>
              </div>
            }
          </div>
          <div class="form-row">
            <div class="form-group col-sm-12">
              <label><b>Observação: (Visita)</b></label>
              <textarea class="form-control form-control-sm" rows="1" name="observacaoVisitaAtual" [(ngModel)]="observacaoVisitaAtual"></textarea>
            </div>
          </div>
          <hr class="mt-2 mb-2" />
          <div class="subtitulo mb-2">Agendar Ligação:</div>
          <div class="form-row">
            <div class="form-group col-sm-2">
              <label><b>Data:</b></label>
              <input class="form-control form-control-sm" type="text" name="agendar_ligacao_data" [ngClass]="{ 'is-invalid': agendarLigacaoDataInvalida }" ngbDatepicker #agendar_ligacao_data="ngbDatepicker" (click)="agendar_ligacao_data.toggle()" [(ngModel)]="agendarLigacaoData" />
              @if (agendarLigacaoDataInvalida) {
                <div class="erro pt-1">Data inválida!</div>
              }
            </div>
            <div class="form-group col-sm-2">
              <label><b>Hora:</b></label>
              <ngb-timepicker name="agendar_ligacao_hora" [spinners]="false" [(ngModel)]="agendarLigacaoHora"></ngb-timepicker>
            </div>
            <div class="form-group col-sm-8">
              <label><b>Mensagem:</b></label>
              <textarea class="form-control form-control-sm" rows="1" name="mensagemLigacao" [(ngModel)]="mensagemLigacao"></textarea>
            </div>
          </div>
          <hr class="mt-2 mb-2" />
          <div class="d-flex flex-wrap justify-content-end">
            <div class="flex-grow-1 text-right">
              <button class="btn btn-success btn_formulario" type="button" (click)="finalizarLigacaoAtual()">Finalizar</button>
            </div>
          </div>
        </div>
      </div>
    }
    <ng-template #resumoFinanceiroModalCC let-modal>
      <div class="modal-header pl-3">
        <h3 class="modal-title"><b>Resumo Financeiro</b></h3>
        <button class="close" type="button" aria-label="Close" (click)="modal.dismiss()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        @if (resumoFinanceiroCarregando) {
          <div class="text-center py-2">
            <span class="text-secondary"><b>Carregando Resumo Financeiro...</b></span>
          </div>
        }
        @if (resumoFinanceiroErro && !resumoFinanceiroCarregando) {
          <div class="text-center py-2">
            <span class="text-danger"><b>Não foi possível carregar o Resumo Financeiro.</b></span>
          </div>
        }
        @if (resumoFinanceiro != null && !resumoFinanceiroCarregando) {
          <div class="mb-1">
            <small class="text-secondary"><b>COD ERP:</b> {{ resumoFinanceiro.codErp }} &nbsp;&nbsp; <b>CLIENTE:</b> {{ resumoFinanceiro.clienteNome }}</small>
            @if (resumoFinanceiro.baixasNominais) {
              <p class="small text-secondary mt-2 mb-1">Valores baixados são nominais e podem incluir compensações, descontos ou outras baixas; não representam necessariamente dinheiro recebido. A data exibida é a última baixa do título.</p>
              @if (resumoFinanceiro.totalBaixadoSemClassificacao > 0) {
                <p class="small text-warning mb-1">Baixas parciais ou sem data, não classificadas nos totais de atraso: {{ resumoFinanceiro.totalBaixadoSemClassificacao | currency: 'BRL' }}.</p>
              }
            }
          </div>
          <div class="d-flex flex-wrap mb-2">
            <div class="confirmacao_item mr-1 mb-1 p-1">
              <h6 class="text-secondary mb-0"><b>TOTAL ABERTO ATRASADO</b></h6>
              <h6 class="text-danger mb-0"><b>{{ resumoFinanceiro.totalAbertoAtrasado | currency: 'BRL' }}</b></h6>
            </div>
            <div class="confirmacao_item mr-1 mb-1 p-1">
              <h6 class="text-secondary mb-0"><b>TOTAL ABERTO EM DIA</b></h6>
              <h6 class="text-success mb-0"><b>{{ resumoFinanceiro.totalAbertoEmDia | currency: 'BRL' }}</b></h6>
            </div>
            <div class="confirmacao_item mr-1 mb-1 p-1">
              <h6 class="text-secondary mb-0"><b>{{ resumoFinanceiro.baixasNominais ? 'TOTAL BAIXADO ATRASADO' : 'TOTAL PAGO ATRASADO' }}</b></h6>
              <h6 class="text-warning mb-0"><b>{{ resumoFinanceiro.totalPagoAtrasado | currency: 'BRL' }}</b></h6>
            </div>
            <div class="confirmacao_item mr-1 mb-1 p-1">
              <h6 class="text-secondary mb-0"><b>{{ resumoFinanceiro.baixasNominais ? 'TOTAL BAIXADO EM DIA' : 'TOTAL PAGO EM DIA' }}</b></h6>
              <h6 class="mb-0"><b>{{ resumoFinanceiro.totalPagoEmDia | currency: 'BRL' }}</b></h6>
            </div>
          </div>
          <div class="table-responsive bg-white">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th class="text-center">EMISSÃO</th>
                  <th class="text-center tabela_borda" style="cursor:pointer;" (click)="alternarOrdemResumoFinanceiroVencimentoCC()">
                    VENCIMENTO
                    <span [style.opacity]="resumoFinanceiroOrdemAtiva === 'vencimento' ? '1' : '0.3'">
                      @if (resumoFinanceiroOrdemVencimentoDesc) {
                        <span>&#9660;</span>
                      }
                      @if (!resumoFinanceiroOrdemVencimentoDesc) {
                        <span>&#9650;</span>
                      }
                    </span>
                  </th>
                  <th class="tabela_borda">NÚMERO NF</th>
                  <th class="tabela_borda">PARCELA</th>
                  <th class="text-right tabela_borda" style="cursor:pointer;" (click)="alternarOrdemResumoFinanceiroCC()">
                    VALOR PARCELA
                    <span [style.opacity]="resumoFinanceiroOrdemAtiva === 'valor' ? '1' : '0.3'">
                      @if (resumoFinanceiroOrdemDesc) {
                        <span>&#9660;</span>
                      }
                      @if (!resumoFinanceiroOrdemDesc) {
                        <span>&#9650;</span>
                      }
                    </span>
                  </th>
                  <th class="text-center tabela_borda">{{ resumoFinanceiro.baixasNominais ? 'ÚLTIMA BAIXA' : 'DATA PAGAMENTO' }}</th>
                  <th class="text-right tabela_borda">{{ resumoFinanceiro.baixasNominais ? 'VALOR BAIXADO' : 'VALOR PAGO' }}</th>
                  @if (resumoFinanceiro.baixasNominais) { <th class="text-right tabela_borda">SALDO ABERTO</th> }
<th class="text-center tabela_borda">DIAS</th>
                  <th class="text-center tabela_borda">STATUS</th>
                </tr>
              </thead>
              <tbody>
                @for (titulo of resumoFinanceiroItens; track titulo) {
                  <tr>
                    <td class="text-center">{{ titulo.docDate | date: 'dd/MM/yyyy' }}</td>
                    <td class="text-center tabela_borda">{{ titulo.dueDate | date: 'dd/MM/yyyy' }}</td>
                    <td class="tabela_borda">{{ titulo.serial }}</td>
                    <td class="tabela_borda">{{ titulo.parcela }}</td>
                    <td class="text-right tabela_borda">{{ titulo.instTotal | currency: 'BRL' }}</td>
                    <td class="text-center tabela_borda">{{ titulo.dataPagamento | date: 'dd/MM/yyyy' }}</td>
                    <td class="text-right tabela_borda">{{ titulo.paidToDate | currency: 'BRL' }}</td>
                    @if (resumoFinanceiro.baixasNominais) { <td class="text-right tabela_borda">{{ titulo.saldoAberto | currency: 'BRL' }}</td> }
                    <td class="text-center tabela_borda">
                      @if (titulo.status?.trim()?.toUpperCase() === 'C' && titulo.dias != null) {
                        <span [ngClass]="titulo.dias < 0 ? 'text-danger' : titulo.dias === 0 ? 'text-success' : 'text-primary'">
                          <b>{{ titulo.dias }}</b>
                        </span>
                      }
                    </td>
                    <td class="text-center tabela_borda">
                      @if (titulo.status?.trim()?.toUpperCase() === 'P') {
                        <span class="badge badge-info">PARCIAL</span>
                      }
                      @if (titulo.status?.trim()?.toUpperCase() === 'O') {
                        <span class="badge badge-warning">ABERTO</span>
                      }
                      @if (titulo.status?.trim()?.toUpperCase() === 'C') {
                        <span class="badge badge-success">{{ resumoFinanceiro.baixasNominais ? 'BAIXADO' : 'PAGO' }}</span>
                      }
                      @if (titulo.status?.trim()?.toUpperCase() !== 'O' && titulo.status?.trim()?.toUpperCase() !== 'C' && titulo.status?.trim()?.toUpperCase() !== 'P') {
                        <span class="badge badge-secondary">{{ titulo.status }}</span>
                      }
                    </td>
                  </tr>
                }
                @if (resumoFinanceiroItens.length === 0) {
                  <tr>
                    <td [attr.colspan]="resumoFinanceiro.baixasNominais ? 10 : 9" class="text-center text-secondary">Nenhum título encontrado.</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.dismiss()">Fechar</button>
      </div>
    </ng-template>

    <div class="ia-overlay" *ngIf="iaPainelAberto" (click)="fecharPainelIa()"></div>
    <aside class="ia-produtos-painel" *ngIf="iaPainelAberto && iaProdutosPainelAberto">
      <div class="ia-painel-header ia-produtos-header">
        <div>
          <span>Produtos sugeridos</span>
          <h3>Segmento e historico do cliente</h3>
        </div>
        <button type="button" class="ia-close" (click)="fecharProdutosIa()">x</button>
      </div>

      <div class="ia-contexto" *ngIf="cliente != null">
        <strong>{{ cliente.name }}</strong>
        <small>ERP: {{ cliente.codigo_no_erp_do_cliente }} | Cliente ID: {{ cliente.client_id_app }}</small>
      </div>

      <div class="ia-sugestoes ia-produtos-resultado" *ngIf="iaSugestao != null">
        <div class="ia-produtos-meta">
          <div class="ia-status" [ngClass]="iaSugestao.sucesso ? 'ia-ok' : 'ia-alerta'">{{ iaSugestao.mensagem }}</div>
          <small *ngIf="iaSugestao.data_pesquisa">Pesquisa: {{ iaSugestao.data_pesquisa | date:'dd/MM/yyyy HH:mm' }}</small>
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="atualizarSugestaoProdutosIa()" [disabled]="iaCarregando">Atualizar</button>
        </div>

        <div class="ia-sugestao-bloco">
          <div class="ia-sugestao-titulo">
            <strong>1. Produtos do segmento que o cliente nao compra</strong>
            <small>{{ produtosIaSegmentoNaoCompra().length }} item(ns)</small>
          </div>
          <ng-container *ngFor="let produto of produtosIaSegmentoNaoCompra()">
            <div class="ia-produto-compacto" (click)="alternarProdutoIa(produto)">
              <strong>{{ produto.produto_nome }}</strong>
              <small>{{ produto.produto_codigo }} | {{ produto.preco_lista | currency:'BRL' }}</small>
              <span>{{ produto.estoque_atual | number:'1.0-0' }} est.</span>
            </div>
            <div class="ia-produto-detalhe" *ngIf="iaProdutoAberto === produto.product_id">
              <p><b>Argumento IA:</b> {{ produto.argumento_venda }}</p>
              <p><b>Preco atual:</b> {{ produto.preco_lista | currency:'BRL' }} | <b>Estoque:</b> {{ produto.estoque_atual | number:'1.0-0' }}</p>
              <div class="ia-condicoes" *ngIf="condicoesProdutoIa(produto).length > 0">
                <b>Condicoes especiais:</b>
                <span *ngFor="let condicao of condicoesProdutoIa(produto)">
                  {{ condicao.tabela_especial_descricao }}: {{ condicao.preco_especial | currency:'BRL' }}
                  <small *ngIf="condicao.qtd_minima">a partir de {{ condicao.qtd_minima | number:'1.0-0' }}</small>
                </span>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="ia-sugestao-bloco">
          <div class="ia-sugestao-titulo">
            <strong>2. Produtos que o cliente ja compra</strong>
            <small>{{ produtosIaClienteCompra().length }} item(ns)</small>
          </div>
          <ng-container *ngFor="let produto of produtosIaClienteCompra()">
            <div class="ia-produto-compacto" (click)="alternarProdutoIa(produto)">
              <strong>{{ produto.produto_nome }}</strong>
              <small>{{ produto.produto_codigo }} | Atual: {{ produto.preco_lista | currency:'BRL' }}</small>
              <span *ngIf="produto.preco_especial">{{ produto.preco_especial | currency:'BRL' }}</span>
              <span *ngIf="!produto.preco_especial">{{ produto.estoque_atual | number:'1.0-0' }} est.</span>
            </div>
            <div class="ia-produto-detalhe" *ngIf="iaProdutoAberto === produto.product_id">
              <p><b>Ultima compra:</b> {{ produto.qtd_ultima_compra | number:'1.0-2' }} un. por {{ produto.preco_ultima_compra | currency:'BRL' }} em {{ produto.data_ultima_compra | date:'dd/MM/yyyy' }}</p>
              <p><b>Preco atual:</b> {{ produto.preco_lista | currency:'BRL' }} | <b>Estoque:</b> {{ produto.estoque_atual | number:'1.0-0' }}</p>
              <div class="ia-condicoes" *ngIf="condicoesProdutoIa(produto).length > 0">
                <b>Condicoes especiais:</b>
                <span *ngFor="let condicao of condicoesProdutoIa(produto)">
                  {{ condicao.tabela_especial_descricao }}: {{ condicao.preco_especial | currency:'BRL' }}
                  <small *ngIf="condicao.qtd_minima">a partir de {{ condicao.qtd_minima | number:'1.0-0' }}</small>
                </span>
              </div>
              <p><b>Segmento:</b> {{ produto.indicado_segmento ? 'Produto tambem indicado para o segmento.' : 'Produto do historico de compra do cliente.' }}</p>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="ia-loading" *ngIf="iaCarregando && iaSugestao == null">Buscando sugestoes de produtos...</div>
    </aside>
    <aside class="ia-painel-lateral" *ngIf="iaPainelAberto && !iaProdutosPainelAberto">
      <div class="ia-painel-header">
        <div>
          <span class="ia-painel-brand">IA NAPIS <small>NEW</small></span>
          <h3>Consultas inteligentes</h3>
        </div>
        <button type="button" class="ia-close" (click)="fecharPainelIa()">x</button>
      </div>

      <div class="ia-contexto" *ngIf="cliente != null">
        <strong>{{ cliente.name }}</strong>
        <small>ERP: {{ cliente.codigo_no_erp_do_cliente }} | Cliente ID: {{ cliente.client_id_app }}</small>
      </div>

      <div class="ia-empty ia-config-loading" *ngIf="iaConfiguracaoCarregando">
        Verificando configuracao da IA NAPIS...
      </div>

      <section class="ia-disabled-hero" *ngIf="!iaConfiguracaoCarregando && !iaModuloHabilitado()">
        <div class="ia-disabled-badge">Novo modulo</div>
        <h1>IA NAPIS</h1>
        <p>
          Use inteligencia artificial para tirar duvidas comerciais, consultar historico do cliente e sugerir produtos com dados reais do Napis.
        </p>

        <div class="ia-disabled-alert">
          Esta funcao ainda nao esta habilitada para a sua empresa. Entre em contato com o suporte para configurar a IA NAPIS.
        </div>

        <div class="ia-disabled-preview">
          <div class="ia-preview-chat">
            <strong>Chat inteligente</strong>
            <span>Respostas comerciais no contexto do cliente</span>
          </div>
          <div class="ia-preview-chat accent">
            <strong>Sugestao de produtos</strong>
            <span>Historico, preco, estoque e condicoes especiais</span>
          </div>
          <div class="ia-preview-chat success">
            <strong>Apoio ao vendedor</strong>
            <span>Argumentos tecnicos e aplicacoes do produto</span>
          </div>
        </div>
      </section>

      <ng-container *ngIf="!iaConfiguracaoCarregando && iaModuloHabilitado()">
      <div class="ia-sugestoes" *ngIf="false && iaSugestao != null">
        <div class="ia-status" [ngClass]="iaSugestao.sucesso ? 'ia-ok' : 'ia-alerta'">{{ iaSugestao.mensagem }}</div>
        <div class="ia-produtos" *ngIf="false && iaSugestao.produtos_sugeridos?.length > 0">
          <div class="ia-produto" *ngFor="let produto of iaSugestao.produtos_sugeridos">
            <strong>{{ produto.produto_nome }}</strong>
            <small>{{ produto.produto_codigo }} | Estoque: {{ produto.estoque_atual | number:'1.0-0' }}</small>
            <span *ngIf="produto.preco_especial">Condição especial: {{ produto.preco_especial | currency:'BRL' }}</span>
            <span *ngIf="!produto.preco_especial">Preço lista: {{ produto.preco_lista | currency:'BRL' }}</span>
            <p>{{ produto.argumento_venda }}</p>
          </div>
        </div>
      </div>

      <div class="ia-chat ia-chat-legado" *ngIf="false">
        <label>Pergunte para a IA</label>
        <textarea class="form-control" rows="4" [(ngModel)]="iaPergunta" placeholder="Ex: Quais produtos posso oferecer para esse cliente?"></textarea>
        <button type="button" class="btn btn-primary btn-block mt-2" (click)="perguntarIa()" [disabled]="iaCarregando || iaPergunta.trim() == ''">Enviar pergunta</button>
      </div>

      <div class="ia-card ia-card-legado" *ngIf="false && iaResposta != null">
        <div class="ia-status" [ngClass]="iaResposta.sucesso ? 'ia-ok' : 'ia-alerta'">{{ iaResposta.mensagem }}</div>
        <pre>{{ iaResposta.resposta }}</pre>
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="copiarTextoIa(iaResposta.resposta)">Copiar resposta</button>
      </div>

      <div class="ia-chatbox">
        <div class="ia-chatbox-topo">
          <div>
            <strong>Chat IA</strong>
            <small>Ultimas 20 interacoes do cliente</small>
          </div>
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="carregarHistoricoIa(true)" [disabled]="iaHistoricoCarregando || iaCarregando">
            Atualizar
          </button>
        </div>

        <div class="ia-chat-lista" #iaChatLista>
          <div class="ia-empty" *ngIf="iaHistoricoCarregando">Carregando historico da IA...</div>
          <div class="ia-empty" *ngIf="!iaHistoricoCarregando && iaMensagens.length === 0">
            Nenhuma conversa anterior com a IA para este cliente.
          </div>

          <div class="ia-msg" *ngFor="let mensagem of iaMensagens" [ngClass]="mensagem.origem === 'USUARIO' ? 'ia-msg-user' : 'ia-msg-assistant'">
            <div class="ia-msg-label">
              <span>{{ mensagem.origem === 'USUARIO' ? 'Voce' : 'IA Napis' }}</span>
              <small *ngIf="mensagem.data">{{ mensagem.data | date:'dd/MM HH:mm' }}</small>
            </div>
            <div class="ia-status" *ngIf="mensagem.mensagem" [ngClass]="mensagem.sucesso ? 'ia-ok' : 'ia-alerta'">{{ mensagem.mensagem }}</div>
            <pre>{{ mensagem.texto }}</pre>
            <button *ngIf="mensagem.origem === 'IA'" type="button" class="btn btn-outline-primary btn-sm" (click)="copiarTextoIa(mensagem.texto)">Copiar</button>

            <div class="ia-produtos" *ngIf="mensagem.produtos_sugeridos?.length > 0">
              <div class="ia-produto" *ngFor="let produto of mensagem.produtos_sugeridos">
                <strong>{{ produto.produto_nome }}</strong>
                <small>{{ produto.produto_codigo }} | Estoque: {{ produto.estoque_atual | number:'1.0-0' }}</small>
                <span *ngIf="produto.preco_especial">Condicao especial: {{ produto.preco_especial | currency:'BRL' }}</span>
                <span *ngIf="!produto.preco_especial">Preco lista: {{ produto.preco_lista | currency:'BRL' }}</span>
                <p>{{ produto.argumento_venda }}</p>
              </div>
            </div>
          </div>

          <div class="ia-digitando" *ngIf="iaCarregando">
            <span></span><span></span><span></span>
          </div>
        </div>

        <div class="ia-chat-input">
          <textarea class="form-control" rows="2" [(ngModel)]="iaPergunta" placeholder="Pergunte para a IA..." (keydown.enter)="enviarPerguntaIaPorEnter($event)"></textarea>
          <button type="button" class="btn btn-primary" (click)="perguntarIa()" [disabled]="iaCarregando || iaPergunta.trim() == ''">Enviar</button>
        </div>
        <div class="ia-sugestao-bloco" *ngIf="false">
          <div class="ia-sugestao-titulo">
            <strong>1. Produtos que o cliente ja compra</strong>
            <small>{{ produtosIaClienteCompra().length }} item(ns)</small>
          </div>
          <div class="ia-produto-compacto" *ngFor="let produto of produtosIaClienteCompra()" (click)="alternarProdutoIa(produto)">
            <strong>{{ produto.produto_nome }}</strong>
            <small>{{ produto.produto_codigo }} | Atual: {{ produto.preco_lista | currency:'BRL' }}</small>
            <span *ngIf="produto.preco_especial">{{ produto.preco_especial | currency:'BRL' }}</span>
            <span *ngIf="!produto.preco_especial">{{ produto.estoque_atual | number:'1.0-0' }} est.</span>
          </div>
          <div class="ia-produto-detalhe" *ngFor="let produto of produtosIaClienteCompra()" [hidden]="iaProdutoAberto !== produto.product_id">
            <p><b>Ultima compra:</b> {{ produto.qtd_ultima_compra | number:'1.0-2' }} un. por {{ produto.preco_ultima_compra | currency:'BRL' }} em {{ produto.data_ultima_compra | date:'dd/MM/yyyy' }}</p>
            <p><b>Preco atual:</b> {{ produto.preco_lista | currency:'BRL' }} | <b>Estoque:</b> {{ produto.estoque_atual | number:'1.0-0' }}</p>
            <p *ngIf="produto.preco_especial"><b>Condicao especial:</b> {{ produto.condicao_especial }} por {{ produto.preco_especial | currency:'BRL' }} <span *ngIf="produto.qtd_minima">a partir de {{ produto.qtd_minima | number:'1.0-0' }}</span></p>
            <p><b>Segmento:</b> {{ produto.indicado_segmento ? 'Produto tambem indicado para o segmento.' : 'Produto do historico de compra do cliente.' }}</p>
          </div>
        </div>
        <div class="ia-sugestao-bloco" *ngIf="false">
          <div class="ia-sugestao-titulo">
            <strong>2. Produtos do segmento que o cliente nao compra</strong>
            <small>{{ produtosIaSegmentoNaoCompra().length }} item(ns)</small>
          </div>
          <div class="ia-produto-compacto" *ngFor="let produto of produtosIaSegmentoNaoCompra()" (click)="alternarProdutoIa(produto)">
            <strong>{{ produto.produto_nome }}</strong>
            <small>{{ produto.produto_codigo }} | {{ produto.preco_lista | currency:'BRL' }}</small>
            <span>{{ produto.estoque_atual | number:'1.0-0' }} est.</span>
          </div>
          <div class="ia-produto-detalhe" *ngFor="let produto of produtosIaSegmentoNaoCompra()" [hidden]="iaProdutoAberto !== produto.product_id">
            <p><b>Argumento IA:</b> {{ produto.argumento_venda }}</p>
            <p><b>Preco atual:</b> {{ produto.preco_lista | currency:'BRL' }} | <b>Estoque:</b> {{ produto.estoque_atual | number:'1.0-0' }}</p>
            <p><b>Motivo:</b> Produto popular no mesmo subsegmento e ainda nao comprado por este cliente.</p>
          </div>
        </div>
      </div>
      </ng-container>
    </aside>
  </div>
}

<ng-template #enviarPdfAnalise let-pedido>
  @if (whatsappAtendimentoAnaliseId != null && clienteConsultaSelecionadoExterno > 0) {
    <button type="button" class="btn btn-sm btn-outline-success ml-2" [disabled]="pedidoPdfEnviando != null || !pedido.order_id_app || !pedido.seller_id"
            (click)="enviarPdfPedidoAnalise(pedido)" ngbTooltip="Enviar PDF na conversa de origem" aria-label="Enviar PDF na conversa de origem"
            [attr.aria-busy]="pedidoPdfEnviando === pedido">
      <i class="fa" [ngClass]="pedidoPdfEnviando === pedido ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'" aria-hidden="true"></i>
    </button>
  }
</ng-template>
